import React, { useEffect, useState, useRef, useMemo } from "react";

import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
} from "@mui/material";
import { Add, Delete, Download, FilterList, MoreVert, Search, FirstPage, LastPage, Close, PhotoCamera, Remove } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";

import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Autocomplete from "@mui/material/Autocomplete";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { autoTable } from "jspdf-autotable";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";

import { useNavigate } from "react-router-dom";

import { RABSearchParams, getRab, createRab, uploadRabPhoto, editRab, fetchRabPhotoBlob, deleteRab, RABDetailSearchParams, getRabDetail, deleteRabDetail } from "../services/rabService.tsx";
import { RAPSearchParams, getRap, createRap, uploadRapPhoto, editRap, fetchRapPhotoBlob, deleteRap, RAPDetailSearchParams, getRapDetail, editRapDetail, deleteRapDetail, SCurveSearchParams, getSCurve, createRapDetail, createSCurve, graphSCurve, editSCurve, deleteSCurve } from "../services/rapService.tsx";
import { fetchAhs } from "../services/ahsService.tsx";
import { getVendors } from "../../data_management/services/vendorService.tsx";
import { getAllProjects } from "../services/projectListingService.tsx";
import { getBidding } from "../../sales/services/biddingProcessService.tsx";
import { getBiddingAdjustmentsByRabDetailId, viewBiddingAdjustment, getBiddingAdjustmentsByRabId, getBiddingAdjustmentsByBiddingId } from "../../sales/services/biddingProcessService.tsx";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

const grafanaURL = process.env.REACT_APP_GRAFANA_URL || "http://localhost:3000";


const projectTypeColors = {
  "PST": "green",
  "MB": "lightgreen",
  "PJTK": "#164396  ",
  "KON": "gray",
  "SK": "orange"
};

interface RabDetail {
  id: string;
  rabId: string;
  ahsId: string;
  volume: string | number;
  totalHarga: string | number;
  hargaSatuan: string | number;
  satuanAHS: string;
  category: string;
  namaAHS: string;
  overheadKoefisien: number;
}

const sources = ["PLN", "BUMN Non-PLN", "Swasta", "Pemerintahan"];
const projectTypes = ["Residential", "Commercial", "Infrastructure", "Industrial"];
const constructionPhases = ["Planning", "Design", "Procurement", "Execution", "Finishing"];
const regions = ["Jamali", "Sulmapana", "Sumkal"];

const RAPPage: React.FC = () => {
  const grafanaChartRef = useRef<HTMLDivElement>(null);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddRapDialog, setOpenAddRapDialog] = useState(false);
  const [openAddItemDetailsDialog, setOpenAddItemDetailsDialog] = useState(false);

  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "name", value: "" }]);

  const [startDateS, setStartDateS] = useState<string | null>(null);
  const [endDateS, setEndDateS] = useState<string | null>(null);

  const [startDateE, setStartDateE] = useState<string | null>(null);
  const [endDateE, setEndDateE] = useState<string | null>(null);

  const [valueMin, setValueMin] = useState("");
  const [valueMax, setValueMax] = useState("");

  const [isEditedRapDetail, setIsEditedRapDetail] = useState(false);
  const [isEditedSCurve, setIsEditedSCurve] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);


  const [ahsOptions, setAhsOptions] = useState<any[]>([]);
  const [vendorOptions, setVendorOptions] = useState<any[]>([]);
  const [biddingOptions, setBiddingOptions] = useState<any[]>([]);
  const [biddingAdjustmentOptions, setBiddingAdjustmentOptions] = useState<any[]>([]);
  const [projectOptions, setProjectOptions] = useState<any[]>([]);
  const [rabOptions, setRabOptions] = useState<any[]>([]);
  const [projects, setProjects] = useState<any[]>([]);

  const [ahsOptionsOnEdit, setAhsOptionsOnEdit] = useState<any[]>([]);
  const [vendorOptionsOnEdit, setVendorOptionsOnEdit] = useState<any[]>([]);
  const [biddingOptionsOnEdit, setBiddingOptionsOnEdit] = useState<any[]>([]);
  const [biddingAdjustmentOptionsOnEdit, setBiddingAdjustmentOptionsOnEdit] = useState<any[]>([]);
  const [projectOptionsOnEdit, setProjectOptionsOnEdit] = useState<any[]>([]);
  const [rabOptionsOnEdit, setRabOptionsOnEdit] = useState<any[]>([]);
  const [projectsOnEdit, setProjectsOnEdit] = useState<any[]>([]);


  const [totalRabAdd, setTotalRabAdd] = useState(0);
  const [totalUpahAdd, setTotalUpahAdd] = useState(0);
  const [totalMaterialAdd, setTotalMaterialAdd] = useState(0);
  const [totalUpahMaterialAdd, setTotalUpahMaterialAdd] = useState(0);
  const [totalBiayaTidakLangsungAdd, setTotalBiayaTidakLangsungAdd] = useState(0);
  const [totalVendorValueAdd, setTotalVendorValueAdd] = useState(0);
  const [totalProyeksiAdd, setTotalProyeksiAdd] = useState(0);

  const [totalRabEdit, setTotalRabEdit] = useState(0);
  const [totalUpahEdit, setTotalUpahEdit] = useState(0);
  const [totalMaterialEdit, setTotalMaterialEdit] = useState(0);
  const [totalUpahMaterialEdit, setTotalUpahMaterialEdit] = useState(0);
  const [totalBiayaTidakLangsungEdit, setTotalBiayaTidakLangsungEdit] = useState(0);
  const [totalVendorValueEdit, setTotalVendorValueEdit] = useState(0);
  const [totalProyeksiEdit, setTotalProyeksiEdit] = useState(0);

  const [bobotAdd, setBobotAdd] = useState(0);
  const [bobotEdit, setBobotEdit] = useState(0);

  const [isVendorAdd, setIsVendorAdd] = useState("");
  const [isVendorEdit, setIsVendorEdit] = useState("");

  const [adjustedRabReviewDataEdit, setAdjustedRabReviewDataEdit] = useState<
    RabDetail[]
  >([]);


  const nullProject = {
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  }

  const [projectAdd, setProjectAdd] = useState<{
    id: string,
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation?: string;
    projectType: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [projectEdit, setProjectEdit] = useState<{
    id: string,
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation?: string;
    projectType: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const fetchAhsList = async () => {
    try {
      const result = await fetchAhs();
      setAhsOptions(result); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };
  const fetchVendorList = async () => {
    try {
      const result = await getVendors({ limit: 10000000 });
      setVendorOptions(result.data); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const fetchBiddingList = async () => {
    try {
      const result = await getBidding({ limit: 10000000 });

      const mappedData = await Promise.all(
        result.data.map(async (bidding) => {
          const biddingAdjustment = await getBiddingAdjustmentsByBiddingId(bidding.id);
          bidding.biddingAdjustment = biddingAdjustment.data;
          return bidding;
        })
      );

      console.log("Biddings", mappedData);
      setProjectOptions(mappedData);
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };


  const fetchProjectList = async () => {
    try {
      const result = await getAllProjects();
      console.log(result);
      setProjects(result); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  function terbilang(nilai) {
    const angka = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];

    function convert(n) {
      n = Math.floor(n);
      if (n < 12) return angka[n];
      else if (n < 20) return convert(n - 10) + " Belas";
      else if (n < 100) return convert(Math.floor(n / 10)) + " Puluh " + convert(n % 10);
      else if (n < 200) return "Seratus " + convert(n - 100);
      else if (n < 1000) return convert(Math.floor(n / 100)) + " Ratus " + convert(n % 100);
      else if (n < 2000) return "Seribu " + convert(n - 1000);
      else if (n < 1000000) return convert(Math.floor(n / 1000)) + " Ribu " + convert(n % 1000);
      else if (n < 1000000000) return convert(Math.floor(n / 1000000)) + " Juta " + convert(n % 1000000);
      else if (n < 1000000000000) return convert(Math.floor(n / 1000000000)) + " Miliar " + convert(n % 1000000000);
      else return "Angka terlalu besar";
    }

    return convert(nilai).replace(/\s+/g, " ").trim();
  }


  const showPopupMandatoryError = (detail) => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: detail,
    });
  };

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };


  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "projectName", label: "Project Name" },
    { value: "source", label: "Source" },
    { value: "projectReferenceId", label: "Kode Project" },
    { value: "region", label: "Region" },
    { value: "projectType", label: "Project Type" },
    { value: "constructionPhase", label: "Project Phase" },
    // { value: "valueEstimation", label: "Value Estimation" },
    { value: "projectAddress", label: "Project Address" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
  ];

  // Daftar pilihan filter yang tersedia
  const availableFiltersInit = [
    { value: "projectName", label: "Project Name" },
    { value: "source", label: "Source" },
    { value: "projectReferenceId", label: "Kode Project" },
    { value: "region", label: "Region" },
    { value: "projectType", label: "Project Type" },
    { value: "constructionPhase", label: "Project Phase" },
    { value: "valueEstimation", label: "Value Estimation" },
    { value: "projectAddress", label: "Project Address" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
  ];

  const [filterParams, setFilterParams] = useState<{
    keyword?: string;
    projectName?: string;
    projectAddress?: string;
    projectReferenceId?: string;
    source?: string;
    projectType?: string;
    constructionPhase?: string;
    region?: string;
    city?: string;
    state?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
    salesProjectId?: string;
    valueEstimation?: string;
    startDate?: string;
    endDate?: string;
    startDateS?: string;
    endDateS?: string;
    startDateE?: string;
    endDateE?: string;
    valueMin?: string;
    valueMax?: string;
    limit?: number;
    offset?: number;
    orderBy?: string;
    order?: string;
  }>({});

  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const fetchRaps = async () => {
    setIsLoading(true);
    try {


      const result = await getRap({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });



      setRows(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalItems(result.total);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchProjectList();
    // fetchAhsList();
    fetchVendorList();
    fetchBiddingList();
    fetchRaps();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  const nullRapData = {
    projectId: "",
    rabId: "",
    rabName: "",
    totalPrice: "0",
    ppn: "11",
    biddingId: "",
    nilaiKontrak: "",
    file: null,
  }

  const [rapData, setRapData] = useState<{
    projectId: string,
    rabId: string,
    rabName: string,
    totalPrice: string,
    ppn: string,
    biddingId: string,
    nilaiKontrak: string,
    file: File | null,
  }>(nullRapData);

  const [errors, setErrors] = useState({
    projectId: false,
    rabId: false,
    rabName: false,
    totalPrice: false,
    ppn: false,
    biddingId: false,
    nilaiKontrak: false,
  });

  const [openEditRabDialog, setOpenEditRabDialog] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [editRapData, setEditRapData] = useState<{
    id: string,
    projectId: string,
    rabId: string,
    biddingId: string,
    rabName: string,
    totalPrice: string,
    ppn: string;
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    projectId: "",
    rabName: "",
    biddingId: "",
    rabId: "",
    totalPrice: "0",
    ppn: "11",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [originalEditRapData, setOriginalEditRapData] = useState<{
    id: string,
    projectId: string,
    rabName: string,
    rabId: string,
    biddingId: string,
    totalPrice: string,
    ppn: string;
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    projectId: "",
    rabName: "",
    rabId: "",
    biddingId: "",
    totalPrice: "0",
    ppn: "11",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [editErrors, setEditErrors] = useState({
    projectId: false,
    rabName: false,
    totalPrice: false,
    ppn: false,
  });

  const nullAhs = {
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
  };

  const [ahsData, setAhsData] = useState<{
    id: string,
    namaAHS: string,
    category: string,
    volume: string,
    satuanAHS: string,
    hargaSatuan: string,
    totalAHS: string,
    totalHarga: string,
    hargaSatuanUpah: string,
    hargaSatuanMaterial: string,
    totalHargaUpahMaterial: string,
    hargaKontrak: string,
    biayaTidakLangsung: string,
    proyeksiPendapatan: string,
    vendor: string,
    vendorProjectValue: string,
  }>({
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
    hargaSatuanUpah: '',
    hargaSatuanMaterial: '',
    totalHargaUpahMaterial: '',
    hargaKontrak: '',
    biayaTidakLangsung: '',
    proyeksiPendapatan: '',
    vendor: '',
    vendorProjectValue: '',
  });

  const [rapDetailAdd, setRapDetailAdd] = useState<Array<{
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
    hargaSatuanUpah: string,
    hargaSatuanMaterial: string,
    hargaKontrak: string,
    biayaTidakLangsung: string,
    proyeksiPendapatan: string,
    vendor: string,
    vendorProjectValue: string,
  }>>([]);

  const availableAhsOptions = useMemo(() => {
    const usedAhsIds = new Set(rapDetailAdd.map((detail) => detail.ahsId));
    return ahsOptions.filter((ahs) => !usedAhsIds.has(ahs.ahsId));
  }, [ahsOptions, rapDetailAdd]);


  const handleAddAhsToRapDetail = () => {
    // Validasi lebih ketat
    if (!ahsData.id || !ahsData.volume || !ahsData.totalHarga || !ahsData.totalHargaUpahMaterial) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan semua data termasuk Total Upah+Material sudah terisi sebelum menambahkan.",
      });
      return;
    }

    console.log("menambahkan ahs data ke detail: ", ahsData);

    const newDetail = {
      ahs: ahsData.ahs,
      rapId: "",
      rabId: rapData.rabId,
      ahsId: ahsData.ahsId,
      biddingAdjustmentId: ahsData.id,
      rabDetailId: ahsData.rabDetailId,
      volume: ahsData.volume,
      totalHarga: Number(ahsData.totalHarga).toString(),
      hargaSatuan: Number(ahsData.hargaSatuanAdjustment),
      satuanAHS: ahsData.satuanAHS,
      category: ahsData.ahs?.category || ahsData.category,
      namaAHS: ahsData.namaAHS,
      hargaSatuanUpah: ahsData.hargaSatuanUpah || "0",
      hargaSatuanMaterial: ahsData.hargaSatuanMaterial || "0",
      hargaKontrak: projectAdd?.bidAmmount || "0",
      biayaTidakLangsung: ahsData.biayaTidakLangsung || "0",
      proyeksiPendapatan: ahsData.proyeksiPendapatan || "0",
      vendor: ahsData.vendor,
      vendorProjectValue: ahsData.vendorProjectValue || "0",
      totalHargaUpahMaterial: ahsData.totalHargaUpahMaterial || "0",
    };

    const updatedDetails = [...rapDetailAdd, newDetail];
    setRapDetailAdd(updatedDetails);

    // Recalculate totals
    recalculateAddTotals(updatedDetails);

    setAhsData(nullAhs); // reset form AHS
  };

  const nullRapDetailToSCurve = {
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  };

  const [rapDetailToSCurveAdd, setRapDetailToSCurveAdd] = useState<{
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>({
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  });

  const [sCurveAdd, setSCurveAdd] = useState<Array<{
    rapId: string;
    ahsId: string;
    rapDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);

  const availableDetailOptions = useMemo(() => {
    const usedAhsIds = new Set(sCurveAdd.map((detail) => detail.ahsId));
    return rapDetailAdd.filter((ahs) => !usedAhsIds.has(ahs.ahsId));
  }, [rapDetailAdd, sCurveAdd]);

  const handleAddRAPToSCurve = () => {
    // Tambahkan validasi untuk totalHargaUpahMaterial
    if (!rapDetailToSCurveAdd.bobotMingguan ||
      !rapDetailToSCurveAdd.durasiMinggu ||
      !rapDetailToSCurveAdd.startDate ||
      !rapDetailToSCurveAdd.endDate ||
      !rapDetailToSCurveAdd.totalHargaUpahMaterial) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan semua data termasuk Total Upah+Material sudah terisi sebelum menambahkan ke S-Curves.",
      });
      return;
    }

    console.log("tambah scurve: ", rapDetailToSCurveAdd);

    const newDetail = {
      rabId: "",
      ahsId: rapDetailToSCurveAdd.ahsId,
      rabDetailId: "",
      nilaiPekerjaan: rapDetailToSCurveAdd.nilaiPekerjaan,
      bobot: rapDetailToSCurveAdd.bobot,
      durasiMinggu: rapDetailToSCurveAdd.durasiMinggu,
      bobotMingguan: rapDetailToSCurveAdd.bobotMingguan,
      startDate: rapDetailToSCurveAdd.startDate,
      endDate: rapDetailToSCurveAdd.endDate,
      namaAHS: rapDetailToSCurveAdd.namaAHS,
      category: rapDetailToSCurveAdd.category,
      totalHargaUpahMaterial: rapDetailToSCurveAdd.totalHargaUpahMaterial || "0",
    };

    setSCurveAdd([...sCurveAdd, newDetail]);
    setRapDetailToSCurveAdd(nullRapDetailToSCurve);
  };


  const [editAhsData, setEditAhsData] = useState<{
    id: string,
    namaAHS: string,
    category: string,
    volume: string,
    satuanAHS: string,
    hargaSatuan: string,
    totalAHS: string,
    totalHarga: string,
    hargaSatuanUpah: string,
    hargaSatuanMaterial: string,
    totalHargaUpahMaterial: string,
    hargaKontrak: string,
    biayaTidakLangsung: string,
    proyeksiPendapatan: string,
    vendor: string,
    vendorProjectValue: string,
  }>({
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
    hargaSatuanUpah: "",
    hargaSatuanMaterial: "",
    totalHargaUpahMaterial: "",
    hargaKontrak: "",
    biayaTidakLangsung: "",
    proyeksiPendapatan: "",
    vendor: "",
    vendorProjectValue: "",
  });

  const [rapDetailAddOnEdit, setRapDetailAddOnEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
    hargaSatuanUpah: string;
    hargaSatuanMaterial: string;
    hargaKontrak: string;
    biayaTidakLangsung: string;
    proyeksiPendapatan: string;
    vendor: string;
    vendorProjectValue: string;
  }>>([]);

  const [rabDetailOriginalEdit, setRabDetailOriginalEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
    hargaSatuanUpah: string;
    hargaSatuanMaterial: string;
    hargaKontrak: string;
    biayaTidakLangsung: string;
    proyeksiPendapatan: string;
    vendor: string;
    vendorProjectValue: string;
  }>>([]);


  const availableAhsOptionsOnEdit = useMemo(() => {
    console.log(rapDetailAddOnEdit);
    const usedAhsIds = new Set(rapDetailAddOnEdit.map((detail) => detail.ahsId));
    console.log(usedAhsIds);
    const theOptions = ahsOptionsOnEdit.filter((ahs) => !usedAhsIds.has(ahs.ahsId));
    console.log(ahsOptionsOnEdit, theOptions);
    return theOptions;
  }, [ahsOptionsOnEdit, rapDetailAddOnEdit]);

  const recalculateAddTotals = (details: Array<{
    volume: string;
    totalHarga: string;
    hargaSatuanUpah: string;
    hargaSatuanMaterial: string;
    biayaTidakLangsung: string;
    proyeksiPendapatan: string;
    vendorProjectValue: string;
    totalHargaUpahMaterial: string; // Tambahkan ini
  }>) => {
    const totalRab = Math.round(
      details.reduce((acc, curr) => acc + Number(curr.totalHarga || 0), 0)
    );
    setTotalRabAdd(totalRab);

    const totalUpah = Math.round(
      details.reduce(
        (acc, curr) =>
          acc + Number(curr.hargaSatuanUpah || 0) * Number(curr.volume || 0),
        0
      )
    );
    setTotalUpahAdd(totalUpah);

    const totalMaterial = Math.round(
      details.reduce(
        (acc, curr) =>
          acc + Number(curr.hargaSatuanMaterial || 0) * Number(curr.volume || 0),
        0
      )
    );
    setTotalMaterialAdd(totalMaterial);

    const totalUpahMaterial = Math.round(totalUpah + totalMaterial);
    setTotalUpahMaterialAdd(totalUpahMaterial);

    const totalBiayaTidakLangsung = Math.round(
      details.reduce((acc, curr) => acc + Number(curr.biayaTidakLangsung || 0), 0)
    );
    setTotalBiayaTidakLangsungAdd(totalBiayaTidakLangsung);

    const totalVendorValue = Math.round(
      details.reduce((acc, curr) => acc + Number(curr.vendorProjectValue || 0), 0)
    );
    setTotalVendorValueAdd(totalVendorValue);

    const totalProyeksi = Math.round(
      details.reduce((acc, curr) => acc + Number(curr.proyeksiPendapatan || 0), 0)
    );
    setTotalProyeksiAdd(totalProyeksi);
  };

  const recalculateEditTotals = (details: Array<{
    volume: string;
    totalHarga: string;
    hargaSatuanUpah: string;
    hargaSatuanMaterial: string;
    biayaTidakLangsung: string;
    proyeksiPendapatan: string;
    vendorProjectValue: string;
    totalHargaUpahMaterial: string; // Tambahkan ini
  }>) => {
    const totalRab = Math.round(
      details.reduce((acc, curr) => acc + Number(curr.totalHarga || 0), 0)
    );
    setTotalRabEdit(totalRab);

    const totalUpah = Math.round(
      details.reduce(
        (acc, curr) =>
          acc + Number(curr.hargaSatuanUpah || 0) * Number(curr.volume || 0),
        0
      )
    );
    setTotalUpahEdit(totalUpah);

    const totalMaterial = Math.round(
      details.reduce(
        (acc, curr) =>
          acc + Number(curr.hargaSatuanMaterial || 0) * Number(curr.volume || 0),
        0
      )
    );
    setTotalMaterialEdit(totalMaterial);

    const totalUpahMaterial = Math.round(totalUpah + totalMaterial);
    setTotalUpahMaterialEdit(totalUpahMaterial);

    const totalBiayaTidakLangsung = Math.round(
      details.reduce((acc, curr) => acc + Number(curr.biayaTidakLangsung || 0), 0)
    );
    setTotalBiayaTidakLangsungEdit(totalBiayaTidakLangsung);

    const totalVendorValue = Math.round(
      details.reduce((acc, curr) => acc + Number(curr.vendorProjectValue || 0), 0)
    );
    setTotalVendorValueEdit(totalVendorValue);

    const totalProyeksi = Math.round(
      details.reduce((acc, curr) => acc + Number(curr.proyeksiPendapatan || 0), 0)
    );
    setTotalProyeksiEdit(totalProyeksi);
  };

  const handleAddAhsToRapDetailOnEdit = () => {
    // Validasi termasuk totalHargaUpahMaterial
    if (!editAhsData.id || !editAhsData.volume || !editAhsData.totalHarga || !editAhsData.totalHargaUpahMaterial) {
      Swal.fire({
        icon: "warning",
        title: "Data AHS belum lengkap",
        text: "Pastikan semua data termasuk Total Upah+Material sudah terisi sebelum menambahkan.",
      });
      return;
    }

    const newDetail = {
      id: "",
      rabId: editRapData.rabId,
      ahsId: editAhsData.id,
      volume: editAhsData.volume,
      totalHarga: editAhsData.totalHarga.toString(),
      hargaSatuan: editAhsData.totalAHS.toString(),
      satuanAHS: editAhsData.satuanAHS,
      category: editAhsData.category,
      namaAHS: editAhsData.namaAHS,
      hargaSatuanUpah: editAhsData.hargaSatuanUpah || "",
      hargaSatuanMaterial: editAhsData.hargaSatuanMaterial || "",
      hargaKontrak: editAhsData.hargaKontrak || "0",
      biayaTidakLangsung: editAhsData.biayaTidakLangsung || "",
      proyeksiPendapatan: editAhsData.proyeksiPendapatan || "0",
      vendor: editAhsData.vendor,
      vendorProjectValue: editAhsData.vendorProjectValue || "0",
      totalHargaUpahMaterial: editAhsData.totalHargaUpahMaterial || "0",
    };

    const updatedDetails = [...rapDetailAddOnEdit, newDetail];
    setRapDetailAddOnEdit(updatedDetails);
    recalculateEditTotals(updatedDetails);
    setIsEditedRapDetail(true);
    setEditAhsData(nullAhs);
  };

  const nullRapDetailToSCurveOnEdit = {
    id: "",
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  }

  const [rapDetailToSCurveAddOnEdit, setRapDetailToSCurveAddOnEdit] = useState<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>({
    id: "",
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  });

  const [sCurveAddOnEdit, setSCurveAddOnEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);

  const [sCurveOriginalEdit, setSCurveOriginalEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);


  const availableDetailOptionsOnEdit = useMemo(() => {
    const usedAhsIds = new Set(sCurveAddOnEdit.map((detail) => detail.ahsId));
    return rapDetailAddOnEdit.filter((ahs) => !usedAhsIds.has(ahs.ahsId));
  }, [rapDetailAddOnEdit, sCurveAddOnEdit]);

  const handleAddRAPToSCurveOnEdit = () => {
    // Tambahkan validasi untuk totalHargaUpahMaterial
    if (!rapDetailToSCurveAddOnEdit.bobotMingguan ||
      !rapDetailToSCurveAddOnEdit.durasiMinggu ||
      !rapDetailToSCurveAddOnEdit.startDate ||
      !rapDetailToSCurveAddOnEdit.endDate ||
      !rapDetailToSCurveAddOnEdit.totalHargaUpahMaterial) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan semua data termasuk Total Upah+Material sudah terisi sebelum menambahkan ke S-Curves.",
      });
      return;
    }

    console.log("tambah scurve on edit: ", rapDetailToSCurveAddOnEdit);

    const newDetail = {
      id: "",
      rapId: editRapData.id,
      rabId: editRapData.rabId,
      ahsId: rapDetailToSCurveAddOnEdit.ahsId,
      rabDetailId: rapDetailToSCurveAddOnEdit.rabDetailId,
      rapDetailId: rapDetailToSCurveAddOnEdit.rapDetailId || "",
      nilaiPekerjaan: rapDetailToSCurveAddOnEdit.nilaiPekerjaan || "0",
      bobot: rapDetailToSCurveAddOnEdit.bobot || "0",
      durasiMinggu: rapDetailToSCurveAddOnEdit.durasiMinggu || "0",
      bobotMingguan: rapDetailToSCurveAddOnEdit.bobotMingguan || "0",
      startDate: rapDetailToSCurveAddOnEdit.startDate,
      endDate: rapDetailToSCurveAddOnEdit.endDate,
      namaAHS: rapDetailToSCurveAddOnEdit.namaAHS || "",
      category: rapDetailToSCurveAddOnEdit.category || "",
      totalHargaUpahMaterial: rapDetailToSCurveAddOnEdit.totalHargaUpahMaterial || "0",
    };

    setSCurveAddOnEdit([...sCurveAddOnEdit, newDetail]);
    setIsEditedSCurve(true);
    setRapDetailToSCurveAddOnEdit({ id: "", ...nullRapDetailToSCurve });
  };


  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (file: File) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setRapData({ ...rapData, file });
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEditRapData({ ...editRapData, file });
  };

  // Fungsi yang sudah ada, pastikan return format-nya konsisten
  // const getBiddingAdjustmentsByBiddingId = async (biddingId: string) => {
  //   try {
  //     const allAdjustments = await viewBiddingAdjustment();

  //     // Pastikan kita selalu mendapatkan array
  //     const adjustmentsArray = Array.isArray(allAdjustments)
  //       ? allAdjustments
  //       : allAdjustments.data || [];

  //     // Filter berdasarkan biddingId
  //     const filteredAdjustments = adjustmentsArray.filter(
  //       (adj) => adj.biddingId === biddingId
  //     );

  //     console.log(
  //       `Found ${filteredAdjustments.length} adjustments for bidding ${biddingId}`
  //     );

  //     // Pastikan return format konsisten
  //     return {
  //       data: filteredAdjustments,
  //       total: filteredAdjustments.length,
  //     };
  //   } catch (error) {
  //     console.error("Error fetching bidding adjustments by biddingId:", error);
  //     // Return empty array format yang konsisten
  //     return { data: [], total: 0 };
  //   }
  // };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRapData({ ...rapData, [name]: value });
  };

  // Ganti signature: terima langsung projectId (string | "")
  const handleProjectChange = async (projectId: string) => {
    if (!projectId) {
      setProjectAdd(nullProject);
      setRabOptions([]);
      setAhsOptions([]);
      // kosongkan rapData secara aman
      setRapData(prev => ({ ...prev, biddingId: "", projectId: "", rabId: "" }));
      return;
    }

    setIsLoading(true);
    const selectedProject = projectOptions.find(proj => String(proj.id) === String(projectId));
    setProjectAdd(selectedProject ?? null);

    console.log("bidding adjustments dari bidding terpilih", selectedProject.biddingAdjustment)

    // Ambil RAB berdasarkan ID/field yang benar
    const result = await getRab({
      projectId: selectedProject?.projectName, // kalau API butuh name, ok; kalau butuh id, ganti ke selectedProject?.id
      limit: 1000000,
      offset,
      orderBy: "createdAt",
      order: "DESC",
    });
    setRabOptions(result.data ?? []);
    setAhsOptions(selectedProject.biddingAdjustment);

    // SATU KALI update rapData, jangan di-overwrite tempat lain
    setRapData(prev => ({
      ...prev,
      biddingId: projectId,
      projectId: selectedProject?.projectName ?? "",
      rabId: selectedProject?.rabName ?? "",
      nilaiKontrak: selectedProject?.bidAmmount ?? ""
    }));

    // panggil handleRabChange dengan rabId yang jelas
    if (selectedProject?.rabName) {
      await handleRabChange({ target: { value: selectedProject.rabName } } as any);
    }

    setIsLoading(false);
  };


  const loadAdjustmentsForEdit = async (
    biddingId: string,
    rabDetails: RabDetail[]
  ) => {
    try {
      // Gunakan fungsi yang sudah diperbaiki
      const existingAdjustments = await getBiddingAdjustmentsByBiddingId(
        biddingId
      );

      console.log("Existing adjustments for edit:", existingAdjustments.data);

      const selectedItems: string[] = [];
      const itemCoefficients: { [key: string]: number } = {};
      const adjustmentTotalPrices: { [key: string]: number } = {};
      const adjustmentUnitPrices: { [key: string]: number } = {};

      let calculatedTotalFromAdjustments = 0;

      // Process each adjustment - AMBIL DATA DARI API
      existingAdjustments.data.forEach((adjustment) => {
        if (adjustment.rabDetailId) {
          selectedItems.push(adjustment.rabDetailId);

          // PERBAIKAN: Convert string koefisien dari API ke number
          const koefisienValue = parseFloat(adjustment.koefisien);
          itemCoefficients[adjustment.rabDetailId] = isNaN(koefisienValue)
            ? 0.1
            : koefisienValue;

          // SIMPAN totalHarga dari adjustment (bukan dari RAB detail)
          const totalHargaValue = parseFloat(adjustment.totalHarga);
          adjustmentTotalPrices[adjustment.rabDetailId] = isNaN(totalHargaValue)
            ? 0
            : totalHargaValue;

          // TAMBAHKAN KE TOTAL
          calculatedTotalFromAdjustments +=
            adjustmentTotalPrices[adjustment.rabDetailId];

          // HITUNG UNIT PRICE DARI TOTAL HARGA DAN VOLUME
          const rabDetail = rabDetails.find(
            (rd) => rd.id === adjustment.rabDetailId
          );
          if (rabDetail) {
            const volume = parseFloat(rabDetail.volume || "1");
            adjustmentUnitPrices[adjustment.rabDetailId] =
              volume > 0 ? totalHargaValue / volume : totalHargaValue;
          }

          console.log("Adjustment data:", {
            rabDetailId: adjustment.rabDetailId,
            koefisien: adjustment.koefisien,
            parsedKoefisien: itemCoefficients[adjustment.rabDetailId],
            totalHarga: adjustment.totalHarga,
            parsedTotalHarga: adjustmentTotalPrices[adjustment.rabDetailId],
            unitPrice: adjustmentUnitPrices[adjustment.rabDetailId],
          });
        }
      });

      setSelectedRabItemsEdit(selectedItems);
      setItemCoefficientsEdit(itemCoefficients);
      setAdjustmentTotalPrices(adjustmentTotalPrices);
      setAdjustmentUnitPrices(adjustmentUnitPrices);

      // PERBAIKAN: Update data RAB review dengan nilai dari adjustments
      if (rabDetails.length > 0) {
        const adjustedData = rabDetails.map((item) => {
          const itemId = item.id || "";
          const isSelected = selectedItems.includes(itemId);

          // GUNAKAN DATA DARI ADJUSTMENT JIKA ADA
          const adjustmentCoefficient =
            itemCoefficients[itemId] !== undefined
              ? itemCoefficients[itemId]
              : item.overheadKoefisien || 0.1;

          const adjustmentTotalPrice =
            adjustmentTotalPrices[itemId] !== undefined
              ? adjustmentTotalPrices[itemId]
              : parseFloat(item.totalHarga || "0");

          const adjustmentUnitPrice =
            adjustmentUnitPrices[itemId] !== undefined
              ? adjustmentUnitPrices[itemId]
              : parseFloat(item.hargaSatuan || "0");

          // PERBAIKAN: Hitung harga dasar dari AHS (bukan dari adjusted price)
          const hargaDasarAHS = item.ahs?.hargaSatuan
            ? parseFloat(item.ahs.hargaSatuan)
            : adjustmentUnitPrice / (1 + adjustmentCoefficient);

          const volume = parseFloat(item.volume || "1");

          return {
            ...item,
            hargaSatuan: adjustmentUnitPrice,
            totalHarga: adjustmentTotalPrice,
            baseHargaSatuan: hargaDasarAHS, // Simpan harga dasar AHS
            customCoefficient: adjustmentCoefficient,
            isSelected: isSelected,
            hasCustomCoefficient: itemCoefficients[itemId] !== undefined,
            volume: volume,
          };
        });

        setAdjustedRabReviewDataEdit(adjustedData);

        // PERBAIKAN: Gunakan calculatedTotalFromAdjustments yang sudah dihitung
        const finalTotal = Object.values(adjustmentTotalPrices).reduce(
          (acc, curr) => acc + curr,
          0
        );

        console.log("Final total from adjustments:", finalTotal);
        console.log("AdjustmentTotalPrices:", adjustmentTotalPrices);

        // PERBAIKAN: Update kedua state total dengan nilai yang sama
        setTotalRabValueEdit(finalTotal);
        setTotalRabValue(finalTotal);

        console.log("Adjusted data with API values:", adjustedData);
        console.log("Total RAB Value Edit:", finalTotal);
      }
    } catch (error) {
      console.warn("Failed to load existing adjustments:", error);
      // Fallback ke data original jika gagal load adjustments
      const fallbackData = rabDetails.map((item) => ({
        ...item,
        hargaSatuan: parseFloat(item.hargaSatuan || "0"),
        totalHarga: parseFloat(item.totalHarga || "0"),
        baseHargaSatuan:
          parseFloat(item.hargaSatuan || "0") /
          (1 + (item.overheadKoefisien || 0.1)),
      }));

      setAdjustedRabReviewDataEdit(fallbackData);

      const fallbackTotal = fallbackData.reduce(
        (acc, curr) => acc + (curr.totalHarga || 0),
        0
      );
      setTotalRabValueEdit(fallbackTotal);
      setTotalRabValue(fallbackTotal);
    }
  };

  const handleRabChange = async (e: { target: { value: string } }) => {
    const rabId = e.target.value ?? "";
    if (!rabId) {
      setRapData(prev => ({ ...prev, rabId: "" }));
      setAhsOptions([]);
      return;
    }

    setIsLoading(true);

    // // 1) Ambil detail RAB
    // const { data: details = [] } = await getRabDetail({ limit: 1000000, rabId });

    // // 2) Isi biddingAdjustment kalau sudah ada di detail, atau fallback array kosong
    // const enrichedDetails = await Promise.all(
    //   details.map(async (detail: any) => {
    //     try {
    //       const adjustments = detail.biddingAdjustments ?? [];
    //       return { ...detail, biddingAdjustment: adjustments };
    //     } catch {
    //       return { ...detail, biddingAdjustment: [] };
    //     }
    //   })
    // );

    // setAhsOptions(enrichedDetails);

    // update hanya field rabId, TANPA menghapus biddingId yang baru diset
    setRapData(prev => ({ ...prev, rabId }));

    setIsLoading(false);
  };


  const handleAhsChange = (e) => {
    if (e.target.value == '') {
      setAhsData(nullAhs);
    } else {
      console.log(e.target.value, "availableAhsOptions = ", availableAhsOptions);
      const selectedAhs = availableAhsOptions.find(opt => opt.id == e.target.value);

      if (selectedAhs) {
        const totalHargaUpahMaterial = selectedAhs.totalHargaUpahMaterial ||
          (Number(selectedAhs.hargaSatuanUpah || 0) * Number(selectedAhs.rabDetail.volume || 0) +
            Number(selectedAhs.hargaSatuanMaterial || 0) * Number(selectedAhs.rabDetail.volume || 0)).toString();

        const updatedSelAhs = {
          ...selectedAhs,
          totalHargaAhs: selectedAhs.ahs.totalHarga || "",
          totalHargaRab: selectedAhs.rabDetail.totalHarga || "",
          totalHarga: selectedAhs.totalHarga || "",
          hargaSatuanAdjustment: selectedAhs.totalHarga ?
            (Number(selectedAhs.totalHarga) / Number(selectedAhs.rabDetail.volume || 1)) :
            Number(selectedAhs.totalHarga || 0) / Number(selectedAhs.rabDetail.volume || 1),
          namaAHS: selectedAhs.ahs?.namaAHS || selectedAhs.namaAHS,
          totalHargaUpahMaterial: totalHargaUpahMaterial,
          // Pastikan semua field penting ada
          hargaSatuanUpah: selectedAhs.hargaSatuanUpah || "",
          hargaSatuanMaterial: selectedAhs.hargaSatuanMaterial || "",
          volume: selectedAhs.rabDetail.volume || "1",
          biayaTidakLangsung: selectedAhs.biayaTidakLangsung || "",
          proyeksiPendapatan: selectedAhs.proyeksiPendapatan || ""
        };

        console.log("Updated AHS Data:", updatedSelAhs);
        setAhsData(updatedSelAhs);
      }
    }
  };

  const handleDetailChange = (e) => {
    if (e.target.value == '') {
      setRapDetailToSCurveAdd(nullRapDetailToSCurve);
    } else {
      const selectedRabDetail = rapDetailAdd.find(detail => detail.ahsId == e.target.value);

      if (selectedRabDetail) {
        // const bobot = (totalUpahMaterialAdd + totalBiayaTidakLangsungAdd) > 0 ? ((Number(selectedRabDetail.hargaSatuanUpah) * Number(selectedRabDetail.volume) + Number(selectedRabDetail.hargaSatuanMaterial) * Number(selectedRabDetail.volume))+Number(selectedRabDetail.biayaTidakLangsung) / (Number(totalUpahMaterialAdd) + Number(totalBiayaTidakLangsungAdd))) : 0;
        const volume = Number(selectedRabDetail.volume);

        const totalUpah =
          Number(selectedRabDetail.hargaSatuanUpah) * volume;

        const totalMaterial =
          Number(selectedRabDetail.hargaSatuanMaterial) * volume;

        const totalBiayaTidakLangsung =
          Number(selectedRabDetail.biayaTidakLangsung);

        const result =
          (totalUpah + totalMaterial + totalBiayaTidakLangsung) /
          (Number(totalUpahMaterialAdd) + Number(totalBiayaTidakLangsungAdd));

        const bobot = (totalUpahMaterialAdd + totalBiayaTidakLangsungAdd) > 0 ? result : 0;

        setRapDetailToSCurveAdd({
          ...selectedRabDetail,
          nilaiPekerjaan: selectedRabDetail?.hargaKontrak || "0",
          totalHargaUpahMaterial: selectedRabDetail?.totalHargaUpahMaterial || "0",
          bobot: bobot.toString()
        });
      } else {
        // Fallback jika tidak ditemukan
        setRapDetailToSCurveAdd({
          ...nullRapDetailToSCurve,
          ahsId: e.target.value
        });
      }
    }
  };

  const handleSCurveInputChange = (e) => {
    const { name, value } = e.target;
    setRapDetailToSCurveAdd({ ...rapDetailToSCurveAdd, [name]: value });
  };

  const handleInputChangeOnEdit = (e) => {
    const { name, value } = e.target;
    setEditRapData({ ...editRapData, [name]: value });
  };

  const handleProjectChangeOnEdit = (e) => {
    let selectedProject;
    if (e.target.value == '') {
      setProjectEdit(nullProject);
      setRabOptionsOnEdit([]);
      setAhsOptionsOnEdit([]);
    } else {
      selectedProject = projectOptions.find(proj => proj.id == e.target.value);
      setProjectEdit(selectedProject);
    }
    setEditRapData({ ...editRapData, projectId: selectedProject?.projectName || "", biddingId: e.target.value });
  };

  const handleAhsChangeOnEdit = (e) => {
    const { name, value } = e.target;

    if (name === "id") {
      if (value === '') {
        setEditAhsData(nullAhs);
        setIsVendorEdit('');
        return;
      }

      const selectedAhs = ahsOptionsOnEdit.find((ahs) => {
        if (ahs?.id) {
          return ahs.id == value;
        }
        return ahs.id == value;
      });

      if (!selectedAhs) {
        setEditAhsData(nullAhs);
        setIsVendorEdit('');
        return;
      }

      const baseAhs = selectedAhs.ahs || selectedAhs;

      // Hitung totalHargaUpahMaterial jika tidak ada
      const totalHargaUpahMaterial = selectedAhs.totalHargaUpahMaterial ||
        ((Number(selectedAhs.hargaSatuanUpah || 0) * Number(selectedAhs.rabDetail.volume || 0)) +
          (Number(selectedAhs.hargaSatuanMaterial || 0) * Number(selectedAhs.rabDetail.volume || 0))).toString();

      const mappedAhs = {
        id: baseAhs?.id || '',
        namaAHS: baseAhs?.namaAHS || '',
        category: selectedAhs?.category || baseAhs?.category || '',
        volume: String(selectedAhs?.rabDetail.volume ?? baseAhs?.rabDetail.volume ?? '1'),
        satuanAHS: baseAhs?.satuanAHS || '',
        hargaSatuan: String(selectedAhs?.hargaSatuan ?? baseAhs?.totalAHS ?? '0'),
        hargaSatuanAdjustment: selectedAhs.totalHarga ?
          (Number(selectedAhs.totalHarga) / Number(selectedAhs.rabDetail.volume || 1)) :
          Number(selectedAhs.totalHarga || 0) / Number(selectedAhs.rabDetail.volume || 1),
        totalAHS: String(baseAhs?.totalAHS ?? selectedAhs?.totalAHS ?? '0'),
        totalHarga: String(selectedAhs?.totalHarga ?? '0'),
        hargaSatuanUpah: String(selectedAhs?.hargaSatuanUpah ?? ''),
        hargaSatuanMaterial: String(selectedAhs?.hargaSatuanMaterial ?? ''),
        totalHargaUpahMaterial: totalHargaUpahMaterial,
        hargaKontrak: String(selectedAhs?.hargaKontrak ?? '0'),
        biayaTidakLangsung: String(selectedAhs?.biayaTidakLangsung ?? ''),
        proyeksiPendapatan: String(selectedAhs?.proyeksiPendapatan ?? '0'),
        vendor: selectedAhs?.vendor ?? '',
        vendorProjectValue: String(selectedAhs?.vendorProjectValue ?? ''),
      };

      setEditAhsData(mappedAhs);
      setIsVendorEdit(mappedAhs.vendor ? "yes" : "no");
      return;
    }

    if (name === "vendor") {
      setIsVendorEdit(value ? "yes" : "no");
    }

    setEditAhsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRabChangeOnEdit = async (e) => {
    if (e.target.value == '') {
      setEditRapData(nullRapData);
    } else {
      await setIsLoading(true);
      // const rabDetail = await getRabDetail({ limit: 1000000, rabId: e.target.value });
      // 1) Ambil detail RAB
      const { data: details = [] } = await getRabDetail({ limit: 1000000, rabId: e.target.value });

      // 2) Ambil bidding adjustments secara paralel & gabungkan ke objek detail
      const enrichedDetails = await Promise.all(
        await details.map(async (detail: any) => {
          try {
            const adjustments = detail.biddingAdjustments;
            return { ...detail, biddingAdjustment: adjustments };
          } catch (e) {
            // fallback total: kalau error apa pun, kosongkan
            return { ...detail, biddingAdjustment: [] };
          }
        })
      );

      await console.log("rap with bidding: ", enrichedDetails);
      setAhsOptionsOnEdit(enrichedDetails);


      // const sCurve = await getSCurve(e.target.value);
      // setSCurveAdd(sCurve);

      await setIsLoading(false);

    }
    setEditRapData({ ...editRapData, rabId: e.target.value });
  };

  const handleDetailChangeOnEdit = (e) => {
    if (e.target.value == '') {
      setRapDetailToSCurveAddOnEdit(nullRapDetailToSCurveOnEdit);
    } else {
      const selectedRabDetail = rapDetailAddOnEdit.find(detail => detail.ahsId == e.target.value);

      if (selectedRabDetail) {
        // const bobot = (totalUpahMaterialEdit + totalBiayaTidakLangsungEdit) > 0 ? (((Number(selectedRabDetail.hargaSatuanUpah) * Number(selectedRabDetail.volume) + Number(selectedRabDetail.hargaSatuanMaterial) * Number(selectedRabDetail.volume)) + Number(selectedRabDetail.biayaTidakLangsung)) / (totalUpahMaterialEdit + totalBiayaTidakLangsungEdit)) : 0;

        // const bobot = (totalUpahMaterialAdd + totalBiayaTidakLangsungAdd) > 0 ? ((Number(selectedRabDetail.hargaSatuanUpah) * Number(selectedRabDetail.volume) + Number(selectedRabDetail.hargaSatuanMaterial) * Number(selectedRabDetail.volume))+Number(selectedRabDetail.biayaTidakLangsung) / (Number(totalUpahMaterialAdd) + Number(totalBiayaTidakLangsungAdd))) : 0;
        const volume = Number(selectedRabDetail.volume);

        const totalUpah =
          Number(selectedRabDetail.hargaSatuanUpah) * volume;

        const totalMaterial =
          Number(selectedRabDetail.hargaSatuanMaterial) * volume;

        const totalBiayaTidakLangsung =
          Number(selectedRabDetail.biayaTidakLangsung);

        const result =
          (totalUpah + totalMaterial + totalBiayaTidakLangsung) /
          (Number(totalUpahMaterialAdd) + Number(totalBiayaTidakLangsungAdd));

        const bobot = (totalUpahMaterialAdd + totalBiayaTidakLangsungAdd) > 0 ? result : 0;

        setRapDetailToSCurveAddOnEdit({
          ...selectedRabDetail,
          nilaiPekerjaan: selectedRabDetail?.totalHarga || "0",
          bobot: bobot.toString(),
          totalHargaUpahMaterial: selectedRabDetail?.totalHargaUpahMaterial ||
            ((Number(selectedRabDetail.hargaSatuanUpah || 0) * Number(selectedRabDetail.volume || 0)) +
              (Number(selectedRabDetail.hargaSatuanMaterial || 0) * Number(selectedRabDetail.volume || 0))).toString()
        });
      } else {
        // Fallback jika tidak ditemukan
        setRapDetailToSCurveAddOnEdit({
          ...nullRapDetailToSCurveOnEdit,
          ahsId: e.target.value
        });
      }
    }
  };

  const handleSCurveInputChangeOnEdit = (e) => {
    const { name, value } = e.target;
    setRapDetailToSCurveAddOnEdit({ ...rapDetailToSCurveAddOnEdit, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {
      projectId: !rapData.projectId,
      rabId: !rapData.rabId,
      // totalPrice: !rapData.totalPrice,
      ppn: !rapData.ppn,
      biddingId: !rapData.biddingId,
      nilaiKontrak: !rapData.nilaiKontrak,
    };

    console.log(newErrors)

    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const validateEditForm = () => {
    let newErrors = {
      projectId: !editRapData.projectId,
      rabId: !editRapData.rabId,
      // totalPrice: !editRapData.totalPrice,
      ppn: !editRapData.ppn,
      biddingId: !editRapData.biddingId,
      // nilaiKontrak: !editRapData.nilaiKontrak,
    };

    setEditErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const errorResponse = (title, error) => {
    let errorTitle = "";
    let errorDetails = "";

    // Handle backend error response
    if (error.response?.data) {
      const backendError = error.response.data;

      // Debug log untuk melihat struktur error
      console.log(
        "Backend Error Structure:",
        JSON.stringify(backendError, null, 2)
      );

      // Main error message
      errorTitle = backendError.error || errorTitle;

      // Handle all possible email validation error formats - PERBAIKAN UTAMA
      const isEmailValidationError =
        // Case 1: Error in details (Sequelize style)
        (backendError.details &&
          /validation isEmail on (email|projectEmail)/i.test(
            backendError.details
          )) ||
        // Case 2: Error in errors array (Sequelize validation errors)
        (backendError.errors &&
          backendError.errors.some(
            (err: any) =>
              (err.path === "email" || err.path === "projectEmail") &&
              err.validatorKey === "isEmail"
          )) ||
        // Case 3: Error in message (generic API responses)
        (backendError.message &&
          /email.*invalid/i.test(backendError.message));

      if (isEmailValidationError) {
        errorTitle = "Format Email Tidak Valid";
        errorDetails =
          "• Format email tidak valid (contoh: nama@perusahaan.com)";
      }
      // Only use details if not an email error
      else if (backendError.details) {
        errorDetails = backendError.details;
      }

      // Handle validation errors (improved processing)
      if (backendError.errors) {
        const validationMessages = backendError.errors
          .map((err: any) => {
            // Handle both array and object error formats
            const errorObj = Array.isArray(err) ? err[0] : err;

            // Skip email errors since we already handled them
            if (
              (errorObj.path === "email" ||
                errorObj.path === "projectEmail") &&
              errorObj.validatorKey === "isEmail"
            ) {
              return null;
            }
            return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
          })
          .filter(Boolean) // Remove null entries
          .join("\n");

        if (validationMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${validationMessages}`
            : validationMessages;
        }
      }

      // Handle duplicate fields (improved formatting)
      if (backendError.duplicates) {
        const duplicateMessages = backendError.duplicates
          .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
          .join("\n");

        if (duplicateMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${duplicateMessages}`
            : duplicateMessages;
        }
      }
    }
    // Handle network or other errors
    else {
      errorDetails =
        error.message || "Terjadi kesalahan jaringan atau server";
    }

    // Show error in Swal (improved formatting)
    Swal.fire({
      icon: "error",
      title: title,
      html: `
                <div style="text-align: left;">
                  <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
                    ${errorTitle}
                  </p>
                  ${errorDetails
          ? `<div style="
                          color: #5f2120;
                          background: #fdecea;
                          padding: 12px;
                          border-radius: 4px;
                          font-size: 0.9em;
                          border-left: 4px solid #d32f2f;
                          line-height: 1.5;
                        ">
                          ${errorDetails.replace(/\n/g, "<br>")}
                        </div>`
          : ""
        }
                </div>
              `,
      confirmButtonColor: "#0F62FE",
      width: "600px",
    });
  }


  const handleSubmitAddRap = async () => {
    if (rapDetailAdd.length > sCurveAdd.length) {
      return showPopupMandatoryError("Lengkapi S-Curve untuk semua RAP Detail."); // Penting: pakai return!
    }

    if (!validateForm()) {
      return showPopupMandatoryError("Lengkapi data yang wajib diisi.");
    }

    try {
      console.log("RAP to Save: ", rapData);

      // const rabSumTotal = { ...rapData, totalPrice: Math.round(totalRabAdd * 1.11) }

      // Step 1: Create RAB
      const newRap = await createRap(rapData);

      if (!newRap?.id) throw new Error("Gagal membuat RAP");
      console.log("newRap :", newRap);

      const updatedRapDetails = rapDetailAdd.map((detail) => ({
        ...detail,
        rapId: newRap.id,
        // ahsId: newRap.ahs.id,
      }));

      const failedDetails: string[] = [];
      const failedSCurves: string[] = [];

      // Step 2: Loop create RapDetail dan SCurve
      for (const detail of updatedRapDetails) {
        try {
          console.log("newRapDetail :", detail);
          const newRapDetail = await createRapDetail(detail);

          if (!newRapDetail?.id) throw new Error("Gagal simpan detail");
          console.log("newRapDetail :", newRapDetail);
          const updatedSCurveAdd = sCurveAdd.find(
            (scurve) => scurve.ahsId === newRapDetail.ahsId
          );
          console.log("updatedSCurveAdd :", updatedSCurveAdd);
          if (updatedSCurveAdd) {
            updatedSCurveAdd.rapDetailId = newRapDetail.id;
            updatedSCurveAdd.rapId = newRap.id;

            try {
              await createSCurve(updatedSCurveAdd);
            } catch (err) {
              console.error("Gagal menyimpan SCurve:", updatedSCurveAdd, err);
              failedSCurves.push(detail.namaAHS);
            }
          } else {
            console.warn("SCurve tidak ditemukan untuk ahsId:", newRapDetail.ahsId);
          }
        } catch (err) {
          console.error("Gagal menyimpan RAP Detail:", detail, err);
          failedDetails.push(detail.namaAHS);
        }
      }

      // Show error jika ada yang gagal
      if (failedDetails.length || failedSCurves.length) {
        const errorText = [
          failedDetails.length && `RAP Detail gagal: ${failedDetails.join(", ")}`,
          failedSCurves.length && `SCurve gagal: ${failedSCurves.join(", ")}`,
        ]
          .filter(Boolean)
          .join("<br>");

        await Swal.fire({
          icon: "error",
          title: "Sebagian data gagal disimpan",
          html: errorText,
        });
      } else {
        // Show success jika semua berhasil
        await Swal.fire({
          icon: "success",
          title: "RAP berhasil ditambahkan",
          confirmButtonColor: "#0F62FE",
        });
      }

      // Reset dan tutup dialog
      setOpenAddRapDialog(false);
      setTotalRabAdd(0);
      setRapDetailAdd([]);
      setSCurveAdd([]);
      setRapData(nullRapData);
      await fetchRaps();
    } catch (error: any) {
      await errorResponse("Gagal membuat RAB", error);
    }
  };

  const handleSubmitEditRap = async () => {
    if (rapDetailAddOnEdit.length > sCurveAddOnEdit.length) {
      return showPopupMandatoryError("Lengkapi S-Curve untuk semua RAP Detail.");
    }

    if (!validateEditForm()) {
      return showPopupMandatoryError("Lengkapi data yang wajib diisi.");
    }

    try {
      setIsLoading(true);

      // Hitung total RAP
      const newTotal = Math.round(
        rapDetailAddOnEdit.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
      );
      const ppnValue = Number(editRapData.ppn || 0);
      const totalWithPpn = Math.round(newTotal * (ppnValue + 100) / 100);

      const updatedRapData = {
        ...editRapData,
        totalPrice: totalWithPpn.toString()
      };

      // Step 1: Update data RAP utama
      const updatedRap = await editRap(updatedRapData);

      if (!updatedRap?.id) {
        throw new Error("Gagal mengupdate RAP");
      }

      console.log("RAP updated:", updatedRap);

      // Step 2: Proses perubahan RAP Detail
      const rapDetailChanges = getRapDetailChanges();
      console.log("RAP Detail Changes:", rapDetailChanges);

      const failedOperations: string[] = [];

      // Hapus RAP Detail yang dihapus
      if (rapDetailChanges.toDelete.length > 0) {
        for (const detailId of rapDetailChanges.toDelete) {
          try {
            await deleteRapDetail(detailId);
            console.log(`Deleted RAP Detail: ${detailId}`);
          } catch (error) {
            console.error(`Gagal menghapus RAP Detail ${detailId}:`, error);
            failedOperations.push(`Gagal menghapus detail ${detailId}`);
          }
        }
      }

      // Update RAP Detail yang berubah
      if (rapDetailChanges.toUpdate.length > 0) {
        for (const detail of rapDetailChanges.toUpdate) {
          try {
            await editRapDetail(detail);
            console.log(`Updated RAP Detail: ${detail.id}`);
          } catch (error) {
            console.error(`Gagal update RAP Detail ${detail.id}:`, error);
            failedOperations.push(`Gagal update detail ${detail.namaAHS}`);
          }
        }
      }

      var newRapDetail = [];

      // Buat RAP Detail baru
      if (rapDetailChanges.toCreate.length > 0) {
        for (const detail of rapDetailChanges.toCreate) {
          try {
            const newDetailData = {
              ...detail,
              rapId: updatedRap.id,
              id: undefined // Pastikan ID tidak ikut untuk create
            };
            const created = await createRapDetail(newDetailData);
            await console.log(`Created new RAP Detail:  `, created);
            await newRapDetail.push(created);
            setRapDetailAddOnEdit([...rapDetailAddOnEdit, created]);
          } catch (error) {
            console.error(`Gagal create RAP Detail ${detail.namaAHS}:`, error);
            failedOperations.push(`Gagal create detail ${detail.namaAHS}`);
          }
        }
      }

      // Step 3: Proses perubahan S-Curve
      const sCurveChanges = getSCurveChanges();
      console.log("S-Curve Changes:", sCurveChanges);

      // Hapus S-Curve yang dihapus
      if (sCurveChanges.toDelete.length > 0) {
        for (const sCurveId of sCurveChanges.toDelete) {
          const selSC = sCurveOriginalEdit.find(sc => sc.id === sCurveId);
          if (!rapDetailChanges.toDelete.includes(selSC.rapDetailId)) {
            try {
              await deleteSCurve(sCurveId);
              console.log(`Deleted S-Curve: ${sCurveId}`);
            } catch (error) {
              console.error(`Gagal menghapus S-Curve ${sCurveId}:`, error);
              failedOperations.push(`Gagal menghapus S-Curve`);
            }
          }

        }
      }

      // Update S-Curve yang berubah
      if (sCurveChanges.toUpdate.length > 0) {
        for (const sCurve of sCurveChanges.toUpdate) {
          try {
            await editSCurve(sCurve);
            console.log(`Updated S-Curve: ${sCurve.id}`);
          } catch (error) {
            console.error(`Gagal update S-Curve ${sCurve.id}:`, error);
            failedOperations.push(`Gagal update S-Curve ${sCurve.namaAHS}`);
          }
        }
      }

      // Buat S-Curve baru
      if (sCurveChanges.toCreate.length > 0) {
        for (const sCurve of sCurveChanges.toCreate) {
          try {
            await console.log(rapDetailAddOnEdit);
            var selRapDetailId = await rapDetailAddOnEdit.find(rd => rd.ahsId == sCurve.ahsId)?.id;
            await console.log("selrap", selRapDetailId);
            await selRapDetailId == '' ? selRapDetailId = await newRapDetail.find(rd => rd.ahsId == sCurve.ahsId)?.id : null;
            await console.log("selrap", selRapDetailId);
            const newSCurveData = await {
              ...sCurve,
              rapId: updatedRap.id,
              rapDetailId: selRapDetailId,
              id: undefined // Pastikan ID tidak ikut untuk create
            };
            await createSCurve(newSCurveData);
            console.log(`Created new S-Curve: ${sCurve.namaAHS}`);
          } catch (error) {
            console.error(`Gagal create S-Curve ${sCurve.namaAHS}:`, error);
            failedOperations.push(`Gagal create S-Curve ${sCurve.namaAHS}`);
          }
        }
      }
      setIsLoading(false);
      // Tampilkan hasil
      if (failedOperations.length > 0) {
        await Swal.fire({
          icon: "warning",
          title: "Sebagian data gagal disimpan",
          html: failedOperations.join("<br>"),
          confirmButtonColor: "#0F62FE",
        });
      } else {
        await Swal.fire({
          icon: "success",
          title: "RAP berhasil diupdate",
          text: "Semua perubahan berhasil disimpan",
          confirmButtonColor: "#0F62FE",
        });
      }

      // Reset dan tutup dialog
      setOpenEditRabDialog(false);
      resetEditStates();
      await fetchRaps();
      setIsLoading(false);

    } catch (error: any) {
      console.error("Error updating RAP:", error);
      await errorResponse("Gagal mengupdate RAP", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fungsi untuk reset state edit
  const resetEditStates = () => {
    setTotalRabEdit(0);
    setRapDetailAddOnEdit([]);
    setSCurveAddOnEdit([]);
    setEditRapData({
      id: "",
      projectId: "",
      rabName: "",
      rabId: "",
      biddingId: "",
      totalPrice: "0",
      ppn: "11",
      file: null,
      salesProjectImage: "",
      previewUrl: "",
    });
    setIsEditedRapDetail(false);
    setIsEditedSCurve(false);
    setRabDetailOriginalEdit([]);
    setSCurveOriginalEdit([]);
    setIsEditing(false);
  };

  const handleOpenEditRap = async (rap) => {
    try {
      console.log("RAP data:", rap);

      const gsc = await graphSCurve(rap.id);

      await console.log("scurve graph: ", gsc);

      if (!rap || !rap.id) {
        console.error("RAP data tidak valid:", rap);
        Swal.fire({
          icon: "error",
          title: "Data tidak valid",
          text: "Data RAP tidak dapat dimuat",
        });
        return;
      }

      // Reset state sebelum memuat data baru
      setIsEditing(false);
      setIsEditedRapDetail(false);
      setIsEditedSCurve(false);

      // Set data RAP utama
      setEditRapData({
        ...rap,
        ppn: rap.ppn ? String(rap.ppn) : editRapData.ppn,
        file: null,
        previewUrl: rap.salesProjectImage || "",
      });

      // Ambil detail RAP
      let rapDetailWithAHS = [];
      try {
        const rapDetail = await getRapDetail({ limit: 1000000, rapId: rap.id });
        await console.log("rapDetail", rapDetail);
        rapDetailWithAHS = rapDetail.data.map((detail) => {
          const ahsDetail = detail.ahs || {};

          return {
            id: detail.id || "",
            rapId: detail.rapId || "",
            ahsId: detail.ahsId || "",
            volume: String(detail.volume ?? ""),
            totalHarga: String(detail.totalHarga ?? detail.totalPrice ?? 0),
            hargaSatuan: String(detail.hargaSatuan ?? ahsDetail.totalAHS ?? 0),
            satuanAHS: detail.satuanAHS || ahsDetail.satuanAHS || "",
            category: detail.category || ahsDetail.category || "",
            namaAHS: detail.namaAHS || ahsDetail.namaAHS || "",
            hargaSatuanUpah: String(detail.hargaSatuanUpah ?? detail.hargaUpah ?? 0),
            hargaSatuanMaterial: String(detail.hargaSatuanMaterial ?? detail.hargaMaterial ?? 0),
            hargaKontrak: String(detail.hargaKontrak ?? 0),
            biayaTidakLangsung: String(detail.biayaTidakLangsung ?? detail.biayaTidakLangsungRap ?? 0),
            proyeksiPendapatan: String(detail.proyeksiPendapatan ?? detail.proyeksiPendapatanRap ?? 0),
            vendor: detail.vendor ?? "",
            vendorProjectValue: String(detail.vendorProjectValue ?? detail.vendorValue ?? 0),
          };
        });
      } catch (error) {
        console.error("Gagal mengambil detail RAP:", error);
        rapDetailWithAHS = [];
      }

      // Ambil S-Curve
      let sCurveWithAHS = [];
      try {
        const sCurve = await getSCurve({ limit: 1000000, rapId: rap.id });
        sCurveWithAHS = sCurve.data.map((sc) => {
          const ahsDetail = sc.rapDetail?.ahs || {};
          return {
            id: sc.id || "",
            rapId: sc.rapId || "",
            ahsId: sc.ahsId || ahsDetail.id,
            rapDetailId: sc.rapDetailId || "",
            nilaiPekerjaan: String(sc.nilaiPekerjaan ?? 0),
            bobot: String(sc.bobot ?? 0),
            durasiMinggu: String(sc.durasiMinggu ?? 0),
            bobotMingguan: String(sc.bobotMingguan ?? 0),
            startDate: sc.startDate || "",
            endDate: sc.endDate || "",
            namaAHS: ahsDetail.namaAHS || sc.namaAHS || "",
            category: ahsDetail.category || sc.category || "",
            totalHargaUpahMaterial: sc.totalHargaUpahMaterial || '0',
          };
        });
      } catch (error) {
        console.error("Gagal mengambil S-Curve:", error);
        sCurveWithAHS = [];
      }

      console.log("Loaded RAP Details:", rapDetailWithAHS);
      console.log("Loaded S-Curves:", sCurveWithAHS);

      // Set data ke state
      // setProjectEdit(rap.project || nullProject);

      const selectedProject = projectOptions.find(proj => String(proj.id) === String(rap.biddingId));
      setProjectEdit(selectedProject ?? null);

      console.log("bidding adjustments dari bidding terpilih", selectedProject.biddingAdjustment)

      setRabOptionsOnEdit(rap.rab ? [rap.rab] : []);
      setAhsOptionsOnEdit(selectedProject.biddingAdjustment ? selectedProject.biddingAdjustment : []);

      // Set data utama untuk edit
      setRapDetailAddOnEdit(rapDetailWithAHS);
      setSCurveAddOnEdit(sCurveWithAHS);

      // Simpan data original untuk referensi
      setRabDetailOriginalEdit([...rapDetailWithAHS]);
      setSCurveOriginalEdit([...sCurveWithAHS]);

      setIsVendorEdit(rapDetailWithAHS.some((detail) => detail.vendor) ? "yes" : "no");
      recalculateEditTotals(rapDetailWithAHS);

      setOriginalEditRapData({
        ...rap,
        ppn: rap.ppn ? String(rap.ppn) : "11",
        file: null,
      });

      const { from, to } = getTimeRangeFromScurve(sCurveWithAHS);
      setIfFrom(from);
      setIfTo(to);

      setOpenEditRabDialog(true);

    } catch (error) {
      console.error("Error dalam handleOpenEditRap:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal memuat data",
        text: "Terjadi kesalahan saat memuat data RAP",
      });
    }
  };

  // Fungsi untuk mendeteksi perubahan pada RAP Detail
  const getRapDetailChanges = () => {
    const changes = {
      toCreate: [] as any[],
      toUpdate: [] as any[],
      toDelete: [] as string[],
    };

    // Deteksi yang dihapus
    rabDetailOriginalEdit.forEach(original => {
      const stillExists = rapDetailAddOnEdit.some(current =>
        current.id === original.id
      );
      if (!stillExists && original.id) {
        changes.toDelete.push(original.id);
      }
    });

    // Deteksi yang baru dan yang diupdate
    rapDetailAddOnEdit.forEach(current => {
      const original = rabDetailOriginalEdit.find(orig => orig.id === current.id);

      if (!original) {
        // Data baru
        changes.toCreate.push(current);
      } else {
        // Cek apakah ada perubahan
        const hasChanges =
          original.volume !== current.volume ||
          original.totalHarga !== current.totalHarga ||
          original.hargaSatuan !== current.hargaSatuan ||
          original.hargaSatuanUpah !== current.hargaSatuanUpah ||
          original.hargaSatuanMaterial !== current.hargaSatuanMaterial ||
          original.biayaTidakLangsung !== current.biayaTidakLangsung ||
          original.proyeksiPendapatan !== current.proyeksiPendapatan ||
          original.vendor !== current.vendor ||
          original.vendorProjectValue !== current.vendorProjectValue;

        if (hasChanges) {
          changes.toUpdate.push(current);
        }
      }
    });

    return changes;
  };

  // Fungsi untuk mendeteksi perubahan pada S-Curve
  const getSCurveChanges = () => {
    const changes = {
      toCreate: [] as any[],
      toUpdate: [] as any[],
      toDelete: [] as string[],
    };

    // Deteksi yang dihapus
    sCurveOriginalEdit.forEach(original => {
      const stillExists = sCurveAddOnEdit.some(current =>
        current.id === original.id
      );
      if (!stillExists && original.id) {
        changes.toDelete.push(original.id);
      }
    });

    // Deteksi yang baru dan yang diupdate
    sCurveAddOnEdit.forEach(current => {
      const original = sCurveOriginalEdit.find(orig => orig.id === current.id);

      if (!original) {
        // Data baru
        changes.toCreate.push(current);
      } else {
        // Cek apakah ada perubahan
        const hasChanges =
          original.nilaiPekerjaan !== current.nilaiPekerjaan ||
          original.bobot !== current.bobot ||
          original.durasiMinggu !== current.durasiMinggu ||
          original.bobotMingguan !== current.bobotMingguan ||
          original.startDate !== current.startDate ||
          original.endDate !== current.endDate;

        if (hasChanges) {
          changes.toUpdate.push(current);
        }
      }
    });

    return changes;
  };

  const handleDeleteRabDetailRow = (indexToRemove: number) => {
    const ahsIdToRemove = rapDetailAdd[indexToRemove].ahsId;

    // Hapus baris dari rapDetailAdd
    const updatedRabDetails = rapDetailAdd.filter((_, idx) => idx !== indexToRemove);
    setRapDetailAdd(updatedRabDetails);

    // // Hitung ulang total setelah penghapusan
    // const newTotal = Math.round(
    //   updatedRabDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    // );
    // setTotalRabAdd(newTotal);
    recalculateAddTotals(updatedRabDetails);

    // Hapus entri yang punya ahsId yang sama dari sCurveAdd
    const updatedSCurves = sCurveAdd.filter((scurve) => scurve.ahsId !== ahsIdToRemove);
    setSCurveAdd(updatedSCurves);
    setIsEditedRapDetail(true);
  };

  const handleDeleteRabDetailEdit = async (indexToRemove: number) => {
    const detailToRemove = rapDetailAddOnEdit[indexToRemove];

    // Hapus dari state
    const updatedRabDetails = rapDetailAddOnEdit.filter((_, idx) => idx !== indexToRemove);
    setRapDetailAddOnEdit(updatedRabDetails);

    // Hapus S-Curve yang terkait
    const updatedSCurves = sCurveAddOnEdit.filter(
      (scurve) => scurve.ahsId !== detailToRemove.ahsId
    );
    setSCurveAddOnEdit(updatedSCurves);

    // Hitung ulang total
    recalculateEditTotals(updatedRabDetails);

    // Tandai ada perubahan
    setIsEditedRapDetail(true);
    setIsEditedSCurve(true);

    // Jika detail sudah ada di database, akan dihapus saat submit
    if (detailToRemove.id) {
      console.log(`Marked RAP Detail for deletion: ${detailToRemove.id}`);
    }
  };

  // Fungsi delete untuk S-Curve individual
  const handleDeleteSCurveEdit = async (indexToRemove: number) => {
    const sCurveToRemove = sCurveAddOnEdit[indexToRemove];

    // Hapus dari state
    const updatedSCurves = sCurveAddOnEdit.filter((_, idx) => idx !== indexToRemove);
    setSCurveAddOnEdit(updatedSCurves);

    // Tandai ada perubahan
    setIsEditedSCurve(true);

    // Jika S-Curve sudah ada di database, akan dihapus saat submit
    if (sCurveToRemove.id) {
      console.log(`Marked S-Curve for deletion: ${sCurveToRemove.id}`);
    }
  };


  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => {
        const deletedRab = await deleteRap(id);

      }));

      Swal.fire({
        icon: "success",
        title: "Rab berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchRaps(); // refresh data
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleCancelEditRab = () => {
    setEditRapData(originalEditRapData); // Kembalikan nilai asli
    setIsEditing(false); // Kunci kembali form
    setOpenEditRabDialog(false);
  };

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "id", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
    const name = filters[index].field;
    if (name === "startDate") { setStartDateS(null); setEndDateS(null); }
    if (name === "endDate") { setStartDateE(null); setEndDateE(null); }
    if (name === "valueEstimation") { setValueMin(""); setValueMax(""); }
    console.log(filters, startDateS, endDateS)
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `RABSearchParams`
      const searchParams: RABSearchParams = {};

      if (startDateS && endDateS) {
        if (startDateS === endDateS) {
          searchParams.startDate = await startDateS;
        } else {
          searchParams.startDateS = await startDateS;
          searchParams.endDateS = await endDateS;
        }
      }

      if (startDateS && !endDateS) {
        searchParams.startDate = await startDateS;
      }

      if (startDateE && endDateE) {
        if (startDateE === endDateE) {
          searchParams.endDate = await startDateE;
        } else {
          searchParams.startDateE = await startDateE;
          searchParams.endDateE = await endDateE;
        }
      }

      if (startDateE && !endDateE) {
        searchParams.endDate = await startDateE;
      }

      if (valueMin && valueMax) {
        if (valueMin === valueMax) {
          searchParams.valueEstimation = await valueMin;
        } else {
          searchParams.valueMin = await valueMin;
          searchParams.valueMax = await valueMax;
        }
      }

      if (valueMin && !valueMax) {
        searchParams.valueEstimation = await valueMin;
      }

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getRab(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
    setStartDateS(null);
    setEndDateS(null);
    setStartDateE(null);
    setEndDateE(null);
    setValueMin("");
    setValueMax("");
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getRab({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams(
        {
          keyword: searchQuery
        }
      );
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatEmployeeForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one employee to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.id))
      //   .map(formatEmployeeForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Rab");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Rabs_${date}.xlsx`);

      // Tutup loading
      Swal.close();

    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export rab data',
      });
    }
  };

  const getTimeRangeFromScurve = (scurveAddOnEdit: any[]) => {
    if (!scurveAddOnEdit || !scurveAddOnEdit.length) return { from: "", to: "" };

    const validDates = scurveAddOnEdit
      .filter(item => item.startDate && item.endDate)
      .map(item => ({
        start: new Date(item.startDate),
        end: new Date(item.endDate)
      }));

    if (validDates.length === 0) return { from: "", to: "" };

    const startDates = validDates.map(item => item.start);
    const endDates = validDates.map(item => item.end);

    const earliestStart = new Date(Math.min(...startDates.map(d => d.getTime())));
    const latestEnd = new Date(Math.max(...endDates.map(d => d.getTime())));

    return {
      from: earliestStart.getTime().toString(),
      to: latestEnd.getTime().toString(),
    };
  };

  const [ifFrom, setIfFrom] = useState("");
  const [ifTo, setIfTo] = useState("");




  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allRabs = await getRab({
      ...filterParams,
      limit: 10000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    return allRabs.data.map(rab => ({
      'Project Name': rab.rabName,
      'Source': rab.projectEmail,
      'Kode Project': rab.projectAddress,
      'Longitude': rab.longitude,
      'Latitude': rab.latitude,
      'Region': rab.region,
      'City': rab.city,
      'District': rab.district,
      'Project Type': rab.projectType,
      'Project Phase': rab.constructionPhase,
      'Start Date': rab.startDate,
      'End Date': rab.endDate,
      'Value Estimation': Number(rab.valueEstimation),
    }));
  };

  const exportRabDetailToPDF = async () => {
    try {
      // Create PDF in landscape orientation
      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      });

      // 1. Add header image (KOP)
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          // Adjust image position for landscape
          doc.addImage(base64Image, "JPEG", 0, 0, 297, 40); // A4 landscape width = 297mm
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      // Add horizontal line after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(10, 45, 287, 45); // Adjusted for landscape width

      // 2. Title section
      const startY = 60;

      // Baris pertama: "RINCIAN ANGGARAN PELAKSANAAN"
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.text("RINCIAN ANGGARAN PELAKSANAAN", 148.5, startY, { align: "center" });

      // Baris kedua: Project Name
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      const projectName = editRapData.project?.projectName || "-";
      doc.text(projectName, 148.5, startY + 8, { align: "center" });

      // ===== RAP DETAILS TABLE =====
      const rapStartY = startY + 20;

      // Siapkan data untuk tabel RAP Details
      const rapDetailsBody = rapDetailAddOnEdit.map((item, i) => [
        `${i + 1}`,
        item.category || "-",
        item.namaAHS || "-",
        item.volume || "-",
        item.satuanAHS || "-",
        `Rp ${Math.round(Number(item.hargaSatuan)).toLocaleString("id-ID")}`,
        `Rp ${Math.round(Number(item.totalHarga)).toLocaleString("id-ID")}`,
        `Rp ${Math.round(Number(item.hargaSatuanUpah)).toLocaleString("id-ID")}`,
        `Rp ${Math.round(Number(item.hargaSatuanUpah) * Number(item.volume)).toLocaleString("id-ID")}`,
        `Rp ${Math.round(Number(item.hargaSatuanMaterial)).toLocaleString("id-ID")}`,
        `Rp ${Math.round(Number(item.hargaSatuanMaterial) * Number(item.volume)).toLocaleString("id-ID")}`,
        `Rp ${Math.round((Number(item.hargaSatuanUpah) * Number(item.volume)) + (Number(item.hargaSatuanMaterial) * Number(item.volume))).toLocaleString("id-ID")}`,
        `Rp ${Math.round(Number(item.biayaTidakLangsung)).toLocaleString("id-ID")}`,
        item.vendor?.vendorName || item.vendor || "-",
        `Rp ${Math.round(Number(item.vendorProjectValue)).toLocaleString("id-ID")}`,
        `Rp ${Math.round(Number(item.proyeksiPendapatan)).toLocaleString("id-ID")}`,
      ]);

      autoTable(doc, {
        head: [
          [
            "No",
            "Category",
            "Keterangan",
            "Volume",
            "Satuan",
            "Harga Satuan Adjustment",
            "Jumlah Harga",
            "Harga Satuan Upah",
            "Total Harga Upah",
            "Harga Satuan Material",
            "Total Harga Material",
            "Total Harga Upah+Material",
            "Biaya Tidak Langsung",
            "Vendor Name",
            "Vendor Value",
            "Proyeksi Pendapatan (AHS-RAP)",
          ],
        ],
        body: rapDetailsBody,
        foot: [
          [
            { content: "Subtotal", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } },
            `Rp ${totalRabEdit.toLocaleString("id-ID")}`,
            "", // Unit Wage
            `Rp ${totalUpahEdit.toLocaleString("id-ID")}`,
            "", // Unit Material
            `Rp ${totalMaterialEdit.toLocaleString("id-ID")}`,
            `Rp ${totalUpahMaterialEdit.toLocaleString("id-ID")}`,
            `Rp ${totalBiayaTidakLangsungEdit.toLocaleString("id-ID")}`,
            "", // Vendor Name
            `Rp ${totalVendorValueEdit.toLocaleString("id-ID")}`,
            `Rp ${totalProyeksiEdit.toLocaleString("id-ID")}`
          ],
          [
            { content: `PPN ${editRapData.ppn}%`, colSpan: 6, styles: { halign: "right" } },
            `Rp ${Math.round(totalRabEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`,
            "",
            `Rp ${Math.round(totalUpahEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`,
            "",
            `Rp ${Math.round(totalMaterialEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`,
            `Rp ${Math.round(totalUpahMaterialEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`,
            `Rp ${Math.round(totalBiayaTidakLangsungEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`,
            "",
            `Rp ${Math.round(totalVendorValueEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`,
            `Rp ${Math.round(totalProyeksiEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`
          ],
          [
            { content: "Total", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } },
            `Rp ${Math.round(totalRabEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`,
            "",
            `Rp ${Math.round(totalUpahEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`,
            "",
            `Rp ${Math.round(totalMaterialEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`,
            `Rp ${Math.round(totalUpahMaterialEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`,
            `Rp ${Math.round(totalBiayaTidakLangsungEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`,
            "",
            `Rp ${Math.round(totalVendorValueEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`,
            `Rp ${Math.round(totalProyeksiEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`
          ]
        ],
        startY: rapStartY,
        margin: { left: 10, right: 10 },
        headStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
          fontSize: 7,
        },
        styles: {
          cellPadding: 1.5,
          fontSize: 6, // Ukuran font lebih kecil untuk landscape
          lineWidth: 0.1,
        },
        columnStyles: {
          0: { cellWidth: 8 },   // No
          1: { cellWidth: 18 },  // Category
          2: { cellWidth: 30 },  // Keterangan
          3: { cellWidth: 12 },  // Volume
          4: { cellWidth: 10 },  // Satuan
          5: { cellWidth: 18 },  // Harga Satuan Adjustment
          6: { cellWidth: 18 },  // Jumlah Harga
          7: { cellWidth: 16 },  // Harga Satuan Upah
          8: { cellWidth: 16 },  // Total Harga Upah
          9: { cellWidth: 16 },  // Harga Satuan Material
          10: { cellWidth: 16 }, // Total Harga Material
          11: { cellWidth: 20 }, // Total Harga Upah+Material
          12: { cellWidth: 16 }, // Biaya Tidak Langsung
          13: { cellWidth: 20 }, // Vendor Name
          14: { cellWidth: 16 }, // Vendor Value
          15: { cellWidth: 20 }, // Proyeksi Pendapatan
        },
        footStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
          fontSize: 7,
        },
        didParseCell: function (data) {
          // Right align untuk kolom numeric
          const numericColumns = [5, 6, 7, 8, 9, 10, 11, 12, 14, 15];
          if (numericColumns.includes(data.column.index)) {
            data.cell.styles.halign = 'right';
          }
        },
        willDrawCell: function (data) {
          // Add borders untuk semua cell
          doc.setDrawColor(0);
          doc.setLineWidth(0.1);
        }
      });

      // ===== SUMMARY SECTION =====
      const tableEndY = (doc as any).lastAutoTable.finalY;
      let summaryY = tableEndY + 5;

      // Check if need new page for summary
      if (summaryY > 190) { // A4 landscape height = 210mm, margin bottom 20mm
        doc.addPage();
        summaryY = 20;
      }

      // Summary table
      const ppnValue = Number(editRapData.ppn || 0);

      // ===== TERBILANG SECTION =====
      const summaryEndY = (doc as any).lastAutoTable.finalY;
      let terbilangY = summaryEndY + 8;

      // Check if need new page for terbilang
      if (terbilangY > 200) {
        doc.addPage();
        terbilangY = 20;
      }

      // Amount in words
      doc.setFontSize(9);
      doc.setFont(undefined, 'normal');
      const totalWithPpn = Math.round(totalProyeksiEdit * (ppnValue + 100) / 100);
      const amountText = `Terbilang: ${terbilang(totalWithPpn)} Rupiah`;

      // Split text if too long
      const wrappedTerbilang = doc.splitTextToSize(amountText, 270);
      doc.text(wrappedTerbilang, 10, terbilangY);

      // ===== FOOTER =====
      const footerY = 200;
      doc.setFontSize(8);
      doc.setTextColor(100);
      // doc.text("Generated by RAP System", 148.5, footerY, { align: "center" });
      doc.text(new Date().toLocaleString('id-ID'), 148.5, footerY + 4, { align: "center" });

      // 3. Save PDF
      const date = new Date().toISOString().slice(0, 10);
      const fileName = `RAP_${projectName.replace(/[^a-zA-Z0-9]/g, '_')}_${date}.pdf`;
      doc.save(fileName);

    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate PDF document",
      });
    }
  };

  const exportRabDetailToExcel = async () => {
    try {
      const project = projectOptions.find(pro => pro.id === editRapData.biddingId) || {};
      const projectName = editRapData.project?.projectName || "-";
      const ppnValue = Number(editRapData.ppn || 0);

      // 1. Create workbook
      const wb = XLSX.utils.book_new();

      // 2. Create RAP Details sheet dengan layout landscape
      const rapDetailsHeader = [
        "No",
        "Category",
        "Keterangan",
        "Volume",
        "Satuan",
        "Harga Satuan Adjustment",
        "Jumlah Harga",
        "Harga Satuan Upah",
        "Total Harga Upah",
        "Harga Satuan Material",
        "Total Harga Material",
        "Total Harga Upah+Material",
        "Biaya Tidak Langsung",
        "Vendor Name",
        "Vendor Value",
        "Proyeksi Pendapatan (AHS-RAP)"
      ];

      const rapDetailsData = rapDetailAddOnEdit.map((item, index) => [
        index + 1,
        item.category || "-",
        item.namaAHS || "-",
        Number(item.volume) || 0,
        item.satuanAHS || "-",
        Math.round(Number(item.hargaSatuan)),
        Math.round(Number(item.totalHarga)),
        Math.round(Number(item.hargaSatuanUpah)),
        Math.round(Number(item.hargaSatuanUpah) * Number(item.volume)),
        Math.round(Number(item.hargaSatuanMaterial)),
        Math.round(Number(item.hargaSatuanMaterial) * Number(item.volume)),
        Math.round((Number(item.hargaSatuanUpah) * Number(item.volume)) + (Number(item.hargaSatuanMaterial) * Number(item.volume))),
        Math.round(Number(item.biayaTidakLangsung)),
        item.vendor?.vendorName || item.vendor || "-",
        Math.round(Number(item.vendorProjectValue)),
        Math.round(Number(item.proyeksiPendapatan))
      ]);

      // Summary calculations
      const subtotalRab = totalRabEdit;
      const subtotalUpah = totalUpahEdit;
      const subtotalMaterial = totalMaterialEdit;
      const subtotalUpahMaterial = totalUpahMaterialEdit;
      const subtotalBiayaTidakLangsung = totalBiayaTidakLangsungEdit;
      const subtotalVendorValue = totalVendorValueEdit;
      const subtotalProyeksi = totalProyeksiEdit;

      const ppnRab = Math.round(totalRabEdit * ppnValue / 100);
      const ppnUpah = Math.round(totalUpahEdit * ppnValue / 100);
      const ppnMaterial = Math.round(totalMaterialEdit * ppnValue / 100);
      const ppnUpahMaterial = Math.round(totalUpahMaterialEdit * ppnValue / 100);
      const ppnBiayaTidakLangsung = Math.round(totalBiayaTidakLangsungEdit * ppnValue / 100);
      const ppnVendorValue = Math.round(totalVendorValueEdit * ppnValue / 100);
      const ppnProyeksi = Math.round(totalProyeksiEdit * ppnValue / 100);

      const totalRabWithPpn = Math.round(totalRabEdit * (ppnValue + 100) / 100);
      const totalUpahWithPpn = Math.round(totalUpahEdit * (ppnValue + 100) / 100);
      const totalMaterialWithPpn = Math.round(totalMaterialEdit * (ppnValue + 100) / 100);
      const totalUpahMaterialWithPpn = Math.round(totalUpahMaterialEdit * (ppnValue + 100) / 100);
      const totalBiayaTidakLangsungWithPpn = Math.round(totalBiayaTidakLangsungEdit * (ppnValue + 100) / 100);
      const totalVendorValueWithPpn = Math.round(totalVendorValueEdit * (ppnValue + 100) / 100);
      const totalProyeksiWithPpn = Math.round(totalProyeksiEdit * (ppnValue + 100) / 100);

      // Tambahkan summary rows
      const summaryRows = [
        [], // empty row
        ["SUB TOTAL", "", "", "", "", "",
          subtotalRab,
          "", subtotalUpah,
          "", subtotalMaterial,
          subtotalUpahMaterial,
          subtotalBiayaTidakLangsung,
          "", subtotalVendorValue,
          subtotalProyeksi
        ],
        [`PPN ${ppnValue}%`, "", "", "", "", "",
          ppnRab,
          "", ppnUpah,
          "", ppnMaterial,
          ppnUpahMaterial,
          ppnBiayaTidakLangsung,
          "", ppnVendorValue,
          ppnProyeksi
        ],
        ["TOTAL", "", "", "", "", "",
          totalRabWithPpn,
          "", totalUpahWithPpn,
          "", totalMaterialWithPpn,
          totalUpahMaterialWithPpn,
          totalBiayaTidakLangsungWithPpn,
          "", totalVendorValueWithPpn,
          totalProyeksiWithPpn
        ],
        [], // empty row
        ["Amount in words:", terbilang(totalProyeksiWithPpn) + " Rupiah"]
      ];

      // Buat worksheet dengan struktur yang sama seperti PDF
      const worksheetData = [
        // Header Title
        ["RINCIAN ANGGARAN PELAKSANAAN"],
        [projectName],
        [], // empty row
        // Table Header
        rapDetailsHeader,
        ...rapDetailsData,
        ...summaryRows
      ];

      const rapDetailsWs = XLSX.utils.aoa_to_sheet(worksheetData);

      // 3. Formatting and styling
      // Column widths untuk layout landscape
      rapDetailsWs["!cols"] = [
        { wch: 5 },   // No
        { wch: 15 },  // Category
        { wch: 30 },  // Keterangan
        { wch: 10 },  // Volume
        { wch: 8 },   // Satuan
        { wch: 15 },  // Harga Satuan Adjustment
        { wch: 15 },  // Jumlah Harga
        { wch: 15 },  // Harga Satuan Upah
        { wch: 15 },  // Total Harga Upah
        { wch: 15 },  // Harga Satuan Material
        { wch: 15 },  // Total Harga Material
        { wch: 18 },  // Total Harga Upah+Material
        { wch: 15 },  // Biaya Tidak Langsung
        { wch: 20 },  // Vendor Name
        { wch: 15 },  // Vendor Value
        { wch: 20 }   // Proyeksi Pendapatan
      ];

      // Merge cells untuk title
      rapDetailsWs["!merges"] = [
        // Title merges
        { s: { r: 0, c: 0 }, e: { r: 0, c: 15 } }, // RINCIAN ANGGARAN PELAKSANAAN
        { s: { r: 1, c: 0 }, e: { r: 1, c: 15 } }, // Project Name

        // Summary merges
        { s: { r: rapDetailsData.length + 4, c: 0 }, e: { r: rapDetailsData.length + 4, c: 5 } }, // SUBTOTAL label
        { s: { r: rapDetailsData.length + 5, c: 0 }, e: { r: rapDetailsData.length + 5, c: 5 } }, // PPN label
        { s: { r: rapDetailsData.length + 6, c: 0 }, e: { r: rapDetailsData.length + 6, c: 5 } }, // TOTAL label
        { s: { r: rapDetailsData.length + 8, c: 0 }, e: { r: rapDetailsData.length + 8, c: 15 } }, // Amount in words
      ];

      // Apply number formatting untuk kolom numeric
      const numericColumns = [5, 6, 7, 8, 9, 10, 11, 12, 14, 15];

      // Format semua cell numeric dengan format currency
      if (!rapDetailsWs["!ref"]) return;
      const range = XLSX.utils.decode_range(rapDetailsWs["!ref"]);

      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cell_address = { c: C, r: R };
          const cell_ref = XLSX.utils.encode_cell(cell_address);

          if (!rapDetailsWs[cell_ref]) continue;

          // Format title rows
          if (R === 0 || R === 1) {
            rapDetailsWs[cell_ref].s = {
              font: { bold: true, sz: 14 },
              alignment: { horizontal: "center" }
            };
          }

          // Format table header
          if (R === 3) {
            rapDetailsWs[cell_ref].s = {
              font: { bold: true },
              fill: { fgColor: { rgb: "646464" } },
              font: { color: { rgb: "FFFFFF" } }
            };
          }

          // Format numeric columns (skip header row)
          if (R > 3 && numericColumns.includes(C)) {
            // Untuk summary rows, format sebagai currency
            if (R >= rapDetailsData.length + 4 && R <= rapDetailsData.length + 6) {
              rapDetailsWs[cell_ref].s = {
                numFmt: '"Rp" #,##0',
                font: { bold: R === rapDetailsData.length + 6 } // Bold untuk TOTAL
              };
            } else {
              // Untuk data rows, format sebagai number
              rapDetailsWs[cell_ref].s = {
                numFmt: '#,##0'
              };
            }
          }

          // Format summary rows
          if (R >= rapDetailsData.length + 4 && R <= rapDetailsData.length + 6) {
            if (C === 0) {
              rapDetailsWs[cell_ref].s = {
                font: { bold: true },
                alignment: { horizontal: "right" }
              };
            }
          }

          // Format amount in words row
          if (R === rapDetailsData.length + 8) {
            rapDetailsWs[cell_ref].s = {
              font: { italic: true }
            };
          }
        }
      }

      // 4. Create additional sheets jika diperlukan (Project Info)
      const projectInfoData = [
        ["PROJECT INFORMATION"],
        [],
        ["RAP Name", editRapData.rabName || "-"],
        ["Project Name", project.projectName || "-"],
        ["Project Code", project.projectReferenceId || "-"],
        ["Project Type", project.projectType || "-"],
        ["Value Estimation", Number(project.valueEstimation || 0)],
        ["Project Address", project.projectAddress || "-"],
        ["Source", project.source || "-"],
        ["Construction Phase", project.constructionPhase || "-"],
        ["Start Date", project.startDate || "-"],
        ["End Date", project.endDate || "-"],
        ["PPN", `${ppnValue}%`],
        ["Generated Date", new Date().toLocaleString('id-ID')]
      ];

      const projectInfoWs = XLSX.utils.aoa_to_sheet(projectInfoData);

      // Format project info sheet
      projectInfoWs["!cols"] = [
        { wch: 25 },
        { wch: 40 }
      ];

      projectInfoWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }
      ];

      // 5. Add sheets to workbook
      XLSX.utils.book_append_sheet(wb, projectInfoWs, "Project Info");
      XLSX.utils.book_append_sheet(wb, rapDetailsWs, "RAP Details");

      // 6. Generate and download Excel file
      const date = new Date().toISOString().slice(0, 10);
      const fileName = `RAP_${projectName.replace(/[^a-zA-Z0-9]/g, '_')}_${date}.xlsx`;
      XLSX.writeFile(wb, fileName);

    } catch (error) {
      console.error("Error exporting to Excel:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate Excel file",
      });
    }
  };

  const exportSCurveToPDF = async () => {
    try {
      // Create PDF in portrait orientation
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      // 1. Add header image (KOP)
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          // Adjust image position for portrait dengan margin
          doc.addImage(base64Image, "JPEG", 10, 0, 190, 40); // Margin kiri-kanan 10mm
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      // Add horizontal line after header dengan margin
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(10, 45, 200, 45); // Dari margin kiri 10mm ke margin kanan 10mm

      // 2. Title section dengan margin yang aman
      const startY = 60;

      // Baris pertama: "S-CURVE" - pastikan tidak melebihi width
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      const title1 = "S-CURVE";
      const title1Width = doc.getTextWidth(title1);
      doc.text(title1, 105, startY, { align: "center" }); // Center di 105mm (tengah A4)

      // Baris kedua: Project Name - batasi width maksimal
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      const projectName = editRapData.project?.projectName || "-";

      // Split project name jika terlalu panjang
      const maxWidth = 180; // Max width dengan margin 15mm kiri-kanan
      let projectNameLines;

      if (doc.getTextWidth(projectName) > maxWidth) {
        projectNameLines = doc.splitTextToSize(projectName, maxWidth);
      } else {
        projectNameLines = [projectName];
      }

      // Tentukan posisi Y untuk project name
      let projectNameY = startY + 8;
      if (projectNameLines.length > 1) {
        projectNameY = startY + 6; // Adjust jika multiple lines
      }

      doc.text(projectNameLines, 105, projectNameY, { align: "center" });

      // ===== S-CURVE DETAILS TABLE =====
      const sCurveStartY = projectNameY + (projectNameLines.length * 5) + 5;

      // Siapkan data untuk tabel S-Curve Details
      const sCurveDetailsBody = sCurveAddOnEdit.map((item, i) => [
        `${i + 1}`,
        item.category || "-",
        item.namaAHS || "-",
        `Rp ${Math.round(Number(item.nilaiPekerjaan)).toLocaleString("id-ID")}`,
        `${(Number(item.bobot) * 100).toFixed(2)}%`,
        `${(Number(item.bobotMingguan) * 100).toFixed(2)}%`,
        `${item.durasiMinggu} minggu`,
        item.startDate || "-",
        item.endDate || "-",
      ]);

      autoTable(doc, {
        head: [
          [
            "No",
            "Category",
            "Keterangan",
            "Nilai Pekerjaan",
            "Bobot",
            "Bobot Mingguan",
            "Durasi",
            "Start",
            "End",
          ],
        ],
        body: sCurveDetailsBody,
        startY: sCurveStartY,
        margin: { left: 10, right: 10 }, // Margin kiri-kanan 10mm
        tableWidth: 190, // Force table width 190mm (210mm - 20mm margin)
        headStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
          fontSize: 6, // Ukuran font lebih kecil
        },
        styles: {
          cellPadding: 1,
          fontSize: 5.5, // Ukuran font lebih kecil
          lineWidth: 0.1,
          overflow: 'linebreak',
          cellWidth: 'wrap'
        },
        columnStyles: {
          0: { cellWidth: 8 },   // No
          1: { cellWidth: 18 },  // Category
          2: { cellWidth: 32 },  // Keterangan
          3: { cellWidth: 22 },  // Nilai Pekerjaan
          4: { cellWidth: 10 },  // Bobot
          5: { cellWidth: 14 },  // Bobot Mingguan
          6: { cellWidth: 12 },  // Durasi
          7: { cellWidth: 18 },  // Start
          8: { cellWidth: 18 },  // End
        },
        didParseCell: function (data) {
          // Right align untuk kolom numeric
          if (data.column.index === 3) { // Nilai Pekerjaan
            data.cell.styles.halign = 'right';
          }
          // Center align untuk kolom persentase dan durasi
          if ([4, 5, 6].includes(data.column.index)) {
            data.cell.styles.halign = 'center';
          }

          // Line break untuk teks panjang di kolom Keterangan
          if (data.column.index === 2 && data.cell.raw) {
            const text = String(data.cell.raw);
            if (text.length > 30) {
              data.cell.text = doc.splitTextToSize(text, 30);
            }
          }
        },
        willDrawCell: function (data) {
          // Add borders untuk semua cell
          doc.setDrawColor(0);
          doc.setLineWidth(0.1);
        }
      });

      // ===== GRAFIK S-CURVE =====
      const tableEndY = (doc as any).lastAutoTable.finalY;
      let chartY = tableEndY + 10;

      // Check if need new page for chart
      if (chartY > 150) {
        doc.addPage();
        chartY = 20;
      }

      // Add chart title dengan margin
      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.text("Grafik S-Curve", 105, chartY, { align: "center" });

      // Add chart image dengan margin
      if (grafanaChartRef.current) {
        try {
          const canvas = await html2canvas(grafanaChartRef.current, {
            scale: 1.0, // Scale lebih kecil
            useCORS: true,
            logging: false,
          });
          const imageData = canvas.toDataURL("image/png");

          // Calculate dimensions to fit in portrait dengan margin
          const maxWidth = 180; // mm dengan margin
          const maxHeight = 100; // mm
          const aspectRatio = canvas.width / canvas.height;

          let chartWidth = maxWidth;
          let chartHeight = chartWidth / aspectRatio;

          if (chartHeight > maxHeight) {
            chartHeight = maxHeight;
            chartWidth = chartHeight * aspectRatio;
          }

          // Center the chart dengan margin
          const chartX = (210 - chartWidth) / 2;

          doc.addImage(imageData, "PNG", chartX, chartY + 5, chartWidth, chartHeight);
        } catch (chartError) {
          console.error("Failed to capture chart:", chartError);
          doc.setFontSize(10);
          doc.setFont(undefined, 'normal');
          doc.text("Grafik tidak dapat dimuat", 105, chartY + 20, { align: "center" });
        }
      } else {
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text("Grafik tidak tersedia", 105, chartY + 20, { align: "center" });
      }

      // ===== FOOTER =====
      const footerY = 280;
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(new Date().toLocaleString('id-ID'), 105, footerY, { align: "center" });

      // 3. Save PDF
      const date = new Date().toISOString().slice(0, 10);
      const fileName = `S-Curve_${projectName.replace(/[^a-zA-Z0-9]/g, '_')}_${date}.pdf`;
      doc.save(fileName);

    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate PDF document",
      });
    }
  };

  const exportSCurveToExcel = async () => {
    try {
      const projectName = editRapData.project?.projectName || "-";

      // 1. Create workbook
      const wb = XLSX.utils.book_new();

      // 2. Create S-Curve Details sheet dengan layout landscape
      const sCurveHeader = [
        "No",
        "Category",
        "Keterangan",
        "Nilai Pekerjaan",
        "Bobot",
        "Bobot Mingguan",
        "Durasi Minggu",
        "Start Date",
        "End Date"
      ];

      const sCurveData = sCurveAddOnEdit.map((item, index) => [
        index + 1,
        item.category || "-",
        item.namaAHS || "-",
        Math.round(Number(item.nilaiPekerjaan)),
        Number(item.bobot),
        Number(item.bobotMingguan),
        Number(item.durasiMinggu),
        item.startDate || "-",
        item.endDate || "-"
      ]);

      // Buat worksheet dengan struktur yang sama seperti PDF
      const worksheetData = [
        // Header Title
        ["S-CURVE"],
        [projectName],
        [], // empty row
        // Table Header
        sCurveHeader,
        ...sCurveData
      ];

      const sCurveWs = XLSX.utils.aoa_to_sheet(worksheetData);

      // 3. Formatting and styling
      // Column widths untuk layout landscape
      sCurveWs["!cols"] = [
        { wch: 5 },   // No
        { wch: 20 },  // Category
        { wch: 35 },  // Keterangan
        { wch: 20 },  // Nilai Pekerjaan
        { wch: 12 },  // Bobot
        { wch: 15 },  // Bobot Mingguan
        { wch: 15 },  // Durasi Minggu
        { wch: 15 },  // Start Date
        { wch: 15 }   // End Date
      ];

      // Merge cells untuk title
      sCurveWs["!merges"] = [
        // Title merges
        { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }, // S-CURVE
        { s: { r: 1, c: 0 }, e: { r: 1, c: 8 } }, // Project Name
      ];

      // Apply number formatting untuk kolom numeric
      if (!sCurveWs["!ref"]) return;
      const range = XLSX.utils.decode_range(sCurveWs["!ref"]);

      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cell_address = { c: C, r: R };
          const cell_ref = XLSX.utils.encode_cell(cell_address);

          if (!sCurveWs[cell_ref]) continue;

          // Format title rows
          if (R === 0 || R === 1) {
            sCurveWs[cell_ref].s = {
              font: { bold: true, sz: 14 },
              alignment: { horizontal: "center" }
            };
          }

          // Format table header
          if (R === 3) {
            sCurveWs[cell_ref].s = {
              font: { bold: true },
              fill: { fgColor: { rgb: "646464" } },
              font: { color: { rgb: "FFFFFF" } }
            };
          }

          // Format numeric columns (skip header row)
          if (R > 3) {
            if (C === 3) { // Nilai Pekerjaan
              sCurveWs[cell_ref].s = {
                numFmt: '"Rp" #,##0'
              };
            } else if (C === 4 || C === 5) { // Bobot dan Bobot Mingguan
              sCurveWs[cell_ref].s = {
                numFmt: '0.00%'
              };
            } else if (C === 6) { // Durasi Minggu
              sCurveWs[cell_ref].s = {
                numFmt: '0'
              };
            }
          }
        }
      }

      // 4. Create Project Info sheet
      const project = projectOptions.find(pro => pro.id === editRapData.projectId) || {};
      const projectInfoData = [
        ["PROJECT INFORMATION"],
        [],
        ["RAP Name", editRapData.rabName || "-"],
        ["Project Name", project.projectName || "-"],
        ["Project Code", project.projectReferenceId || "-"],
        ["Project Type", project.projectType || "-"],
        ["Value Estimation", Number(project.valueEstimation || 0)],
        ["Project Address", project.projectAddress || "-"],
        ["Source", project.source || "-"],
        ["Construction Phase", project.constructionPhase || "-"],
        ["Start Date", project.startDate || "-"],
        ["End Date", project.endDate || "-"],
        ["Generated Date", new Date().toLocaleString('id-ID')]
      ];

      const projectInfoWs = XLSX.utils.aoa_to_sheet(projectInfoData);

      // Format project info sheet
      projectInfoWs["!cols"] = [
        { wch: 25 },
        { wch: 40 }
      ];

      projectInfoWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }
      ];

      // 5. Add sheets to workbook
      XLSX.utils.book_append_sheet(wb, projectInfoWs, "Project Info");
      XLSX.utils.book_append_sheet(wb, sCurveWs, "S-Curve Details");

      // 6. Generate and download Excel file
      const date = new Date().toISOString().slice(0, 10);
      const fileName = `S-Curve_${projectName.replace(/[^a-zA-Z0-9]/g, '_')}_${date}.xlsx`;
      XLSX.writeFile(wb, fileName);

    } catch (error) {
      console.error("Error exporting to Excel:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate Excel file",
      });
    }
  };

  return (

    <Box sx={{ padding: 3 }}>
      {isLoading ? <LoadingOverlay /> : null}
      {/* Header & Tabs */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          RAP List
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select value={rowsPerPage} onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1); // reset ke halaman 1 saat ganti limit
          }} size="small">
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          <Button
            startIcon={<Delete />}
            variant="text"
            onClick={() => {
              const selectedData = rows.filter((row) => selectedRows.includes(row.rabid));
              setItemsToDelete(selectedData);
              setOpenDeleteDialog(true);
            }}
            disabled={selectedRows.length === 0}
          >
            Delete
          </Button>
          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>
          {/* <Button startIcon={<Download />} variant="contained" className="exportButton" onClick={() => handleExport()}>
              Export
            </Button> */}
          <Button startIcon={<Add />} variant="contained" className="addItemDetailsButton" onClick={() => { setOpenAddRapDialog(true) }}>
            Add New RAP
          </Button>
        </Box>
      </Box>


      {/* Delete Button & Subtitle */}

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of All RAP
        </Typography>
      </Box>


      {/* Table */}

      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              {/* Checkbox header */}
              <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.id))
                  }
                />
              </TableCell>
              <TableCell>No</TableCell>

              {/* Urutan kolom sesuai screenshot */}
              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectName")}
                style={{ cursor: "pointer" }}
              >
                <strong>Project Name</strong>
                {sortConfig.orderBy === "projectName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectSource")}
                style={{ cursor: "pointer" }}
              >
                <strong>Source</strong>
                {sortConfig.orderBy === "projectSource" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectReferenceId")}
                style={{ cursor: "pointer" }}
              >
                <strong>Kode Project</strong>
                {sortConfig.orderBy === "projectReferenceId" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("region")}
                style={{ cursor: "pointer" }}
              >
                <strong>Region</strong>
                {sortConfig.orderBy === "region" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("rab.totalPrice")}
                style={{ cursor: "pointer" }}
              >
                <strong>RAB Value</strong>
                {sortConfig.orderBy === "rab.totalPrice" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("nilaiKontrak")}
                style={{ cursor: "pointer" }}
              >
                <strong>RAP Value</strong>
                {sortConfig.orderBy === "nilaiKontrak" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("proyeksiPendapatan")}
                style={{ cursor: "pointer" }}
              >
                <strong>Estimasi Pendapatan</strong>
                {sortConfig.orderBy === "proyeksiPendapatan" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("projectType")}
                style={{ cursor: "pointer" }}
              >
                <strong>Project Type</strong>
                {sortConfig.orderBy === "projectType" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("constructionPhase")}
                style={{ cursor: "pointer" }}
              >
                <strong>Project Phase</strong>
                {sortConfig.orderBy === "constructionPhase" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("startDate")}
                style={{ cursor: "pointer" }}
              >
                <strong>Start Date</strong>
                {sortConfig.orderBy === "startDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell
                className="tableCell"
                onClick={() => handleSort("endDate")}
                style={{ cursor: "pointer" }}
              >
                <strong>End Date</strong>
                {sortConfig.orderBy === "endDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>

              <TableCell className="tableCell" />
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                {/* Checkbox */}
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    checked={selectedRows.includes(row.id)}
                    onChange={() => handleSelectRow(row.id)}
                  />
                </TableCell>

                <TableCell>
                  {/* Nomor urut disesuaikan dengan pagination */}
                  {offset + index + 1}
                </TableCell>


                {/* Project Name */}
                <TableCell className="tableCell" title={row.project?.projectName}>
                  <strong>{row.project?.projectName || "-"}</strong>
                </TableCell>

                {/* Source */}
                <TableCell className="tableCell" title={row.project?.source}>
                  {row.project?.source || "-"}
                </TableCell>

                {/* Kode Project */}
                <TableCell className="tableCell" title={row.project?.projectReferenceId}>
                  {row.project?.projectReferenceId || "-"}
                </TableCell>

                {/* Region */}
                <TableCell className="tableCell" title={row.project?.region}>
                  {row.project?.region || "-"}
                </TableCell>

                {/* RAB Value (pakai totalPrice yg sudah ada) */}
                <TableCell className="tableCell" title={String(row.rab.totalPrice)}>
                  {Number(row.rab.totalPrice)}
                </TableCell>

                {/* RAP Value (fallback '-' kalau field belum ada) */}
                <TableCell className="tableCell" title={String(row.nilaiKontrak ?? "")}>
                  {row.nilaiKontrak !== undefined ? Number(row.nilaiKontrak) : "-"}
                </TableCell>

                {/* Estimasi Pendapatan (fallback '-') */}
                <TableCell className="tableCell" title={String(row.proyeksiPendapatan ?? "")}>
                  {row.proyeksiPendapatan !== undefined ? Number(row.proyeksiPendapatan) : "-"}
                </TableCell>

                {/* Project Type */}
                <TableCell className="tableCell" title={row.project?.projectType}>
                  {row.project?.projectType || "-"}
                </TableCell>

                {/* Project Phase */}
                <TableCell className="tableCell" title={row.project?.constructionPhase}>
                  {row.project?.constructionPhase || "-"}
                </TableCell>

                {/* Start / End Date */}
                <TableCell className="tableCell" title={row.project?.startDate}>
                  {row.project?.startDate || "-"}
                </TableCell>
                <TableCell className="tableCell" title={row.project?.endDate}>
                  {row.project?.endDate || "-"}
                </TableCell>

                {/* More options */}
                <TableCell className="tableCell">
                  <IconButton onClick={() => { setTotalRabEdit(0); handleOpenEditRap(row); }}>
                    <MoreVert />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>
        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Delete Rows?</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete the selected rows?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={handleDeleteRows} color="error">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* POPUP Add New RAP */}
      <Dialog open={openAddRapDialog} onClose={() => setOpenAddRapDialog(false)} fullWidth maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" fontWeight="bold">Add New RAP</Typography>
            <IconButton onClick={() => setOpenAddRapDialog(false)} color="error"><Close /></IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }} gutterBottom>Project</Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Autocomplete
              fullWidth
              options={projectOptions}
              // tampilkan nama langsung dari option
              // getOptionLabel={(option) => option?.projectName ?? ""}
              getOptionLabel={(option) => projects.find((pro) => pro.id == option.projectName)?.projectName || ""}
              // getOptionLabel={(option) => option.projectName || ""} value={projectOptions.find(opt => opt.id === rapData.biddingId) || null}
              // penting: bandingkan option vs value by id
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              // controlled value berdasarkan biddingId
              value={projectOptions.find(opt => opt.id === rapData.biddingId) ?? null}
              onChange={(_, newValue) => {
                // langsung kirim id (atau kosong)
                handleProjectChange(newValue ? newValue.id : "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Project Name"
                  name="projectName"
                  placeholder="Enter project name"
                  fullWidth
                  error={!rapData.projectId}
                  helperText={!rapData.projectId ? "Mandatory Field" : ""}
                />
              )}
            />

            <Autocomplete
              fullWidth disabled
              options={rabOptions}
              getOptionLabel={(option) => option.rabName || ""}
              value={rabOptions.find(opt => opt.id === rapData.rabId) || null}
              onChange={(event, newValue) => {
                handleRabChange({
                  target: {
                    name: "rabId",
                    value: newValue ? newValue.id : ""
                  }
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="RAB Name" name="rabId"
                  placeholder="Enter RAB name"
                  fullWidth
                  error={!rapData.rabId}
                  helperText={!rapData.rabId ? "Mandatory Field" : ""}
                />
              )}
            />
            <TextField
              fullWidth label="PPN" name="ppn"
              placeholder="Enter PPN" value={rapData.ppn}
              onChange={(e) => handleInputChange(e)}
              error={!rapData.ppn}
              helperText={!rapData.ppn ? "Mandatory Field" : ""}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
            {/* Project */}
            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2 }}>

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }} gutterBottom>Input AHS</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>

                <Autocomplete
                  fullWidth
                  options={availableAhsOptions}
                  getOptionLabel={(option) => option.ahs?.namaAHS || ""}
                  value={
                    ahsData?.id
                      ? availableAhsOptions.find((opt) => opt.id === ahsData.id) || null
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleAhsChange({
                      target: {
                        name: "id",
                        value: newValue ? newValue.id : ""
                      }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="AHS Name"
                      name="namaAHS"
                      placeholder="Enter ahs name"
                      fullWidth
                      error={!ahsData.id}
                      helperText={!ahsData.id ? "Mandatory Field" : ""}
                    />
                  )}
                />

                <TextField
                  fullWidth label="AHS Category" name="ahsCategory"
                  placeholder="Enter AHS Category" value={ahsData?.ahs?.category || ""}
                  disabled
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Satuan AHS" name="satuanAHS"
                  placeholder="Enter satuan AHS" value={ahsData?.ahs?.satuanAHS || ""}
                  disabled
                />

                <TextField
                  fullWidth label="Harga Satuan (Rp)" name="hargaSatuan"
                  placeholder="Enter harga satuan AHS" value={ahsData?.hargaSatuanAdjustment || ""}
                  disabled
                />

                <TextField
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={ahsData?.volume || ""}
                  // onChange={(e) => setAhsData({ ...ahsData, volume: e.target.value, totalHarga: (Number(ahsData.totalAHS) * Number(e.target.value)) })}
                  disabled
                />

                {/* <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={ahsData.totalHarga}
                  disabled
                /> */}
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Harga Satuan Upah" name="hargaSatuanUpah"
                  placeholder="Harga satuan Upah" value={ahsData.hargaSatuanUpah || ""}
                  onChange={(e) => setAhsData({ ...ahsData, hargaSatuanUpah: e.target.value, totalHargaUpahMaterial: ((Number(ahsData.volume) * Number(e.target.value)) + ((Number(ahsData.volume) * Number(ahsData.hargaSatuanMaterial)) || 0)).toString() })}
                  error={!ahsData.hargaSatuanUpah}
                  helperText={!ahsData.hargaSatuanUpah ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Harga Satuan Material" name="hargaSatuanMaterial"
                  placeholder="Harga satuan material" value={ahsData.hargaSatuanMaterial || ""}
                  onChange={(e) => setAhsData({ ...ahsData, hargaSatuanMaterial: e.target.value, totalHargaUpahMaterial: ((Number(ahsData.volume) * Number(e.target.value)) + ((Number(ahsData.volume) * Number(ahsData.hargaSatuanUpah)) || 0)).toString() })}
                  error={!ahsData.hargaSatuanMaterial}
                  helperText={!ahsData.hargaSatuanMaterial ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Total Harga Upah+Material (Rp)" name="totalHarga"
                  placeholder="Total harga satuan upah+material" value={ahsData.totalHargaUpahMaterial || ""}
                  onChange={(e) => setAhsData({ ...ahsData, proyeksiPendapatan: ((Number(ahsData.totalHarga)) - (Number(ahsData.totalHargaUpahMaterial) - Number(ahsData.biayaTidakLangsung)) || 0).toString() })}
                  disabled
                />

                {/* <TextField
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={ahsData.volume}
                  onChange={(e) => setAhsData({ ...ahsData, volume: e.target.value, totalHarga: (Number(ahsData.totalAHS) * Number(e.target.value)) })}
                  error={!ahsData.volume}
                  helperText={!ahsData.volume ? "Mandatory Field" : ""}
                /> */}

                {/* <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={ahsData.totalHarga}
                  disabled
                /> */}
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Harga Kontrak" name="hargaKontrak"
                  placeholder="Harga kontrak" value={projectAdd.bidAmmount || ""}
                  disabled
                // onChange={(e) => setAhsData({ ...ahsData, hargaKontrak: e.target.value })}
                // error={!ahsData.hargaKontrak}
                // helperText={!ahsData.hargaKontrak ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Biaya Tidak Langsung" name="biayaTidakLangsung"
                  placeholder="Biaya Tidak Langsung" value={ahsData.biayaTidakLangsung || ""}
                  onChange={(e) => setAhsData({ ...ahsData, biayaTidakLangsung: e.target.value, proyeksiPendapatan: ((Number(ahsData.totalHarga)) - Number(ahsData.totalHargaUpahMaterial) - Number(e.target.value) || 0).toString() })}
                  error={!ahsData.biayaTidakLangsung}
                  helperText={!ahsData.biayaTidakLangsung ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth disabled
                  label="Proyeksi Pendapatan" name="proyeksiPendapatan"
                  placeholder="Proyeksi Pendapatan" value={ahsData.proyeksiPendapatan || ""}
                  onChange={(e) => setAhsData({ ...ahsData, proyeksiPendapatan: e.target.value })}
                  error={!ahsData.proyeksiPendapatan}
                  helperText={!ahsData.proyeksiPendapatan ? "Mandatory Field" : ""}
                />

                {/* <TextField
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={ahsData.volume}
                  onChange={(e) => setAhsData({ ...ahsData, volume: e.target.value, totalHarga: (Number(ahsData.totalAHS) * Number(e.target.value)) })}
                  error={!ahsData.volume}
                  helperText={!ahsData.volume ? "Mandatory Field" : ""}
                /> */}

                {/* <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={ahsData.totalHarga}
                  disabled
                /> */}
              </Box>


            </Box>



            {/* Right Side (Dropdowns & Inputs) */}
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }} gutterBottom>Vendor</Typography>
              <TextField
                select
                fullWidth label="Use Vendor" name="isVendorAdd"
                placeholder="Select Option" value={isVendorAdd}
                onChange={(e) => setIsVendorAdd(e.target.value)}
              >
                <MenuItem value="" disabled>Select Option</MenuItem>
                <MenuItem value="yes">Yes</MenuItem>
                <MenuItem value="no">No</MenuItem>
              </TextField>
              {/* <TextField
                select
                fullWidth label="Vendor" name="vendor"
                placeholder="Select Vendor" value={ahsData.vendor}
                disabled={(isVendorAdd != "yes")}
              >
                <MenuItem value="" disabled>Select Vendor</MenuItem>
                {vendorOptions.map((option) => (
                  <MenuItem key={option.vendorId} value={option.vendorId}>
                    {option.vendorName}
                  </MenuItem>
                ))}
              </TextField> */}
              <Autocomplete
                fullWidth
                disabled={isVendorAdd !== "yes"}
                options={vendorOptions}
                getOptionLabel={(option) => option?.vendorName ?? ""}
                isOptionEqualToValue={(opt, val) => opt.vendorId === val.vendorId}
                value={
                  ahsData.vendor
                    ? vendorOptions.find(opt => opt.vendorId === ahsData.vendor) ?? null
                    : null
                }
                onChange={(_, newValue) => {
                  setAhsData(prev => ({ ...prev, vendor: newValue ? newValue.vendorId : "" }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Vendor Name"
                    name="vendor"
                    placeholder="Enter vendor name"
                    fullWidth
                    error={isVendorAdd == "yes" && !ahsData.vendor}
                    helperText={isVendorAdd == "yes" && !ahsData.vendor ? "Mandatory Field" : ""}
                  />
                )}
              />

              <TextField
                fullWidth label="Vendor Project Value" name="vendorProjectValue"
                placeholder="Vendor Project Value" value={ahsData.vendorProjectValue}
                onChange={(e) => setAhsData({ ...ahsData, vendorProjectValue: e.target.value })}
                disabled={(isVendorAdd != "yes")}
              />
            </Box>
          </Box>

          {/* AHS */}

          {/* Left Side (Inputs & Map) */}
          <Box sx={{ flex: 3, display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>

            <Button
              variant="outlined"
              color="primary"
              sx={{ width: 180 }}
              onClick={handleAddAhsToRapDetail}
            >
              Tambahkan ke RAP Detail
            </Button>



          </Box>
          {/* Section A - RAB Review */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>A. RAP Review</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>No</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Keterangan</TableCell>
                  <TableCell>Volume</TableCell>
                  <TableCell>Satuan</TableCell>
                  <TableCell>Harga Satuan Adjustment</TableCell>
                  <TableCell>Jumlah Harga</TableCell>
                  <TableCell>Harga Satuan Upah</TableCell>
                  <TableCell>Total Harga Upah</TableCell>
                  <TableCell>Harga Satuan Material</TableCell>
                  <TableCell>Total Harga Material</TableCell>
                  <TableCell>Total Harga Upah+Material</TableCell>
                  <TableCell>Biaya Tidak Langsung</TableCell>
                  <TableCell>Vendor Name</TableCell>
                  <TableCell>Vendor Value</TableCell>
                  <TableCell>Proyeksi Pendapatan (AHS-RAP)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rapDetailAdd.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <IconButton
                        color="error"
                        onClick={() => {
                          handleDeleteRabDetailRow(index);
                          // setRapDetailAdd((prev) => prev.filter((_, i) => i !== index));
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.ahs?.category}</TableCell>
                    <TableCell>{row.namaAHS}</TableCell>
                    <TableCell>{row.volume}</TableCell>
                    <TableCell>{row.ahs?.satuanAHS}</TableCell>
                    <TableCell>{`Rp ${Number(row.hargaSatuan).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${Number(row.totalHarga).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${Number(row.hargaSatuanUpah).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${(Number(row.hargaSatuanUpah) * Number(row.volume)).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${Number(row.hargaSatuanMaterial).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${(Number(row.hargaSatuanMaterial) * Number(row.volume)).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${(Number(row.hargaSatuanMaterial) * Number(row.volume) + Number(row.hargaSatuanUpah) * Number(row.volume)).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${Number(row.biayaTidakLangsung).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{vendorOptions.find((vendor) => vendor.vendorId === row.vendor)?.vendorName || ""}</TableCell>
                    <TableCell>{`Rp ${Number(row.vendorProjectValue).toLocaleString("id-ID")}` || ""}</TableCell>
                    <TableCell>{`Rp ${Number(row.proyeksiPendapatan).toLocaleString("id-ID")}`}</TableCell>
                  </TableRow>
                ))}
                {/* Hitungan Akhir */}
                <TableRow>
                  <TableCell colSpan={7} align="right"><strong>Jumlah</strong></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalRabAdd).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalUpahAdd).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalMaterialAdd).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalUpahMaterialAdd).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalBiayaTidakLangsungAdd).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalVendorValueAdd).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalProyeksiAdd).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={7} align="right">PPN {rapData.ppn}%</TableCell>
                  <TableCell>
                    {`Rp ${Math.round(totalRabAdd * Number(rapData.ppn) / 100).toLocaleString("id-ID")}`}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalUpahAdd * Number(rapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalMaterialAdd * Number(rapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalUpahMaterialAdd * Number(rapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalBiayaTidakLangsungAdd * Number(rapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalVendorValueAdd * Number(rapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalProyeksiAdd * Number(rapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={7} align="right"><strong>Total</strong></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalRabAdd * (Number(rapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalUpahAdd * (Number(rapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalMaterialAdd * (Number(rapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalUpahMaterialAdd * (Number(rapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalBiayaTidakLangsungAdd * (Number(rapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalVendorValueAdd * (Number(rapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalProyeksiAdd * (100 + Number(rapData.ppn)) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            {/* <Typography variant="body2" sx={{ mt: 1 }}>
              Terbilang: {terbilang(Math.round(rapDetailAdd.reduce((acc, curr) => acc + Number(curr.totalHarga), 0) * 1.11))} Rupiah
            </Typography> */}

          </Box>

          {/* S-Curves */}

          {/* Left Side (Inputs & Map) */}
          <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>B. S-Curve</Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Autocomplete
                fullWidth
                options={availableDetailOptions}
                getOptionLabel={(option) => option.namaAHS || ""}
                value={availableDetailOptions.find(opt => opt.ahsId === rapDetailToSCurveAdd.ahsId) || null}
                onChange={(event, newValue) => {
                  handleDetailChange({
                    target: {
                      name: "ahsId",
                      value: newValue ? newValue.ahsId : ""
                    }
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="AHS Name" name="namaAHS"
                    placeholder="Enter ahs name"
                    fullWidth error={!rapDetailToSCurveAdd.ahsId}
                    helperText={!rapDetailToSCurveAdd.ahsId ? "Mandatory Field" : ""}
                  />
                )}
              />
              <TextField
                fullWidth
                label="Total Upah+Material"
                name="totalHargaUpahMaterial"
                placeholder="Enter Total Upah+Material"
                value={String(rapDetailToSCurveAdd.totalHargaUpahMaterial || "0")}
                disabled
                error={!rapDetailToSCurveAdd.totalHargaUpahMaterial}
                helperText={!rapDetailToSCurveAdd.totalHargaUpahMaterial ? "Mandatory Field" : ""}
              />
              <TextField
                fullWidth label="Bobot" name="bobot"
                placeholder="Enter Bobot" value={String(rapDetailToSCurveAdd.bobot || "")}
                onChange={handleSCurveInputChange}
                disabled
                error={!rapDetailToSCurveAdd.bobot}
                helperText={!rapDetailToSCurveAdd.bobot ? "Mandatory Field" : ""}
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth label="Durasi (Minggu)" name="durasiMinggu"
                placeholder="Enter Durasi (Minggu)" value={String(rapDetailToSCurveAdd.durasiMinggu || "")}
                // disabled
                onChange={(e) => setRapDetailToSCurveAdd({ ...rapDetailToSCurveAdd, durasiMinggu: e.target.value, endDate: rapDetailToSCurveAdd.startDate ? dayjs(rapDetailToSCurveAdd.startDate).add(Number(e.target.value), 'week').format("YYYY-MM-DD") : "", bobotMingguan: (Number(rapDetailToSCurveAdd.bobot) / Number(e.target.value)) })}
                error={!rapDetailToSCurveAdd.durasiMinggu}
                helperText={!rapDetailToSCurveAdd.durasiMinggu ? "Mandatory Field" : ""}
              />
              <TextField
                fullWidth label="Bobot Mingguan" name="bobotMingguan"
                placeholder="Enter Bobot Mingguan" value={String(rapDetailToSCurveAdd.bobotMingguan || "")}
                disabled
                onChange={handleSCurveInputChange}
                error={!rapDetailToSCurveAdd.bobotMingguan}
                helperText={!rapDetailToSCurveAdd.bobotMingguan ? "Mandatory Field" : ""}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="Select Start Date"
                  format="YYYY-MM-DD"
                  value={rapDetailToSCurveAdd.startDate ? dayjs(rapDetailToSCurveAdd.startDate) : null}
                  onChange={(newValue) => {
                    // if (isEditing) {
                    setRapDetailToSCurveAdd({ ...rapDetailToSCurveAdd, startDate: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "", endDate: newValue ? dayjs(newValue).add(Number(rapDetailToSCurveAdd.durasiMinggu), 'week').format("YYYY-MM-DD") : "" })
                    // }
                  }}
                  slotProps={{
                    textField: {
                      margin: "normal",
                      fullWidth: true,
                      sx: { mb: 1, mt: 0 },
                      name: "startDate",
                      error: !rapDetailToSCurveAdd.startDate,
                      helperText: !rapDetailToSCurveAdd.startDate ? "Mandatory Field" : "",
                    },
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  disabled
                  label="Select End Date"
                  format="YYYY-MM-DD"
                  value={rapDetailToSCurveAdd.endDate ? dayjs(rapDetailToSCurveAdd.endDate) : null}
                  onChange={(newValue) => {
                    // if (isEditing) {
                    handleSCurveInputChange({
                      target: {
                        name: "endDate",
                        value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                      },
                    });
                    // }
                  }}
                  slotProps={{
                    textField: {
                      margin: "normal",
                      fullWidth: true,
                      sx: { mb: 1, mt: 0 },
                      name: "endDate",
                      error: !rapDetailToSCurveAdd.endDate,
                      helperText: !rapDetailToSCurveAdd.endDate ? "Mandatory Field" : "",
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>

            <Button
              variant="outlined"
              color="primary"
              sx={{ width: 180 }}
              onClick={handleAddRAPToSCurve}
            >
              Tambahkan ke S-Curve
            </Button>



          </Box>

          {/* Section B - S-Curve */}
          <Box sx={{ mt: 5 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Table S-Curve</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>No</TableCell>
                  <TableCell>Category AHS</TableCell>
                  <TableCell>Keterangan</TableCell>
                  <TableCell>Total Harga Upah + Material</TableCell>
                  <TableCell>Bobot</TableCell>
                  <TableCell>Bobot Minggu</TableCell>
                  <TableCell>Total Durasi</TableCell>
                  <TableCell>Start</TableCell>
                  <TableCell>End</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sCurveAdd.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <IconButton
                        color="error"
                        onClick={() => {
                          setSCurveAdd((prev) => prev.filter((_, i) => i !== index));
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.category}</TableCell>
                    <TableCell>{row.namaAHS}</TableCell>
                    <TableCell>{`Rp ${Number(row.totalHargaUpahMaterial)?.toLocaleString("id-ID") || "0"}`}</TableCell>
                    <TableCell>{row.bobot}</TableCell>
                    <TableCell>{row.bobotMingguan}</TableCell>
                    <TableCell>{row.durasiMinggu}</TableCell>
                    <TableCell>{row.startDate}</TableCell>
                    <TableCell>{row.endDate}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          <Button variant="outlined" color="error" sx={{ width: 120 }} onClick={() => setOpenAddRapDialog(false)}>CANCEL</Button>
          <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitAddRap}>SAVE</Button>
        </DialogActions>
      </Dialog>

      {/* POPUP Edit RAP */}
      <Dialog open={openEditRabDialog} onClose={() => setOpenEditRabDialog(false)} fullWidth maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" fontWeight="bold">Edit RAP</Typography>
            <IconButton onClick={() => setOpenEditRabDialog(false)} color="error"><Close /></IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }} gutterBottom>Project</Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Autocomplete
              fullWidth
              disabled={!isEditing}
              options={projectOptions}
              getOptionLabel={(option) => projects.find((pro) => pro.id == option.projectName)?.projectName || ""}
              // getOptionLabel={(option) => option.projectName || ""}
              value={projectOptions.find(opt => opt.id === editRapData.biddingId) || null}
              onChange={(event, newValue) => {
                handleProjectChangeOnEdit({
                  target: {
                    name: "biddingId",
                    value: newValue ? newValue.id : ""
                  }
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Project Name" name="projectName"
                  placeholder="Enter project name"
                  fullWidth
                  disabled={!isEditing}
                  error={!editRapData.biddingId}
                  helperText={!editRapData.biddingId ? "Mandatory Field" : ""}
                />
              )}
            />
            <Autocomplete
              fullWidth
              disabled={!isEditing}
              options={rabOptionsOnEdit}
              getOptionLabel={(option) => option.rabName || ""}
              value={rabOptionsOnEdit.find(opt => opt.id === editRapData.rabId) || null}
              onChange={(event, newValue) => {
                handleRabChangeOnEdit({
                  target: {
                    name: "rabId",
                    value: newValue ? newValue.id : ""
                  }
                });
                // setEditRapData((prev) => ({
                //   ...prev,
                //   rabId: newValue ? newValue.id : "",
                //   rabName: newValue?.rabName || prev.rabName,
                // }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  disabled={!isEditing}
                  label="RAB Name" name="rabId"
                  placeholder="Enter RAB name"
                  fullWidth
                  error={!editRapData.rabId}
                  helperText={!editRapData.rabId ? "Mandatory Field" : ""}
                />
              )}
            />
            <TextField
              fullWidth label="PPN" name="ppn"
              disabled={!isEditing}
              placeholder="Enter PPN" value={editRapData.ppn}
              onChange={(e) => handleInputChangeOnEdit(e)}
              error={!editRapData.ppn}
              helperText={!editRapData.ppn ? "Mandatory Field" : ""}
            />
          </Box>
          <Box sx={{ display: isEditing ? "flex" : "none", gap: 2, flexWrap: "wrap", mt: 1 }} hidden={!isEditing}>
            {/* Project */}
            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2 }}>

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }} gutterBottom>Input AHS</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>

                <Autocomplete
                  fullWidth
                  disabled={!isEditing}
                  options={availableAhsOptionsOnEdit}
                  getOptionLabel={(option) => option.ahs?.namaAHS || ""}
                  value={
                    editAhsData?.id
                      ? availableAhsOptionsOnEdit.find((opt) => opt.id === editAhsData.id) || null
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleAhsChangeOnEdit({
                      target: {
                        name: "id",
                        value: newValue ? newValue.id : ""
                      }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      disabled={!isEditing}
                      label="AHS Name"
                      name="namaAHS"
                      placeholder="Enter ahs name"
                      fullWidth
                      error={!editAhsData.id}
                      helperText={!editAhsData.id ? "Mandatory Field" : ""}
                    />
                  )}
                />

                <TextField
                  fullWidth label="AHS Category" name="ahsCategory"
                  placeholder="Enter AHS Category" value={editAhsData?.category || ""}
                  disabled
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Satuan AHS" name="satuanAHS"
                  placeholder="Enter satuan AHS" value={editAhsData?.satuanAHS || ""}
                  disabled
                />

                <TextField
                  fullWidth label="Harga Satuan (Rp)" name="hargaSatuan"
                  placeholder="Enter harga satuan AHS" value={editAhsData?.totalHarga || ""}
                  disabled
                />

                <TextField
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={editAhsData?.volume || ""}
                  // onChange={(e) => setEditAhsData({ ...editAhsData, volume: e.target.value, totalHarga: (Number(editAhsData.totalAHS) * Number(e.target.value)) })}
                  disabled
                />

                {/* <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={editAhsData.totalHarga}
                  disabled
                /> */}
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Harga Satuan Upah" name="hargaSatuanUpah"
                  disabled={!isEditing}
                  placeholder="Harga satuan Upah" value={editAhsData.hargaSatuanUpah || ""}
                  onChange={(e) => setEditAhsData({ ...editAhsData, hargaSatuanUpah: e.target.value, totalHargaUpahMaterial: ((Number(editAhsData.volume) * Number(e.target.value)) + ((Number(editAhsData.volume) * Number(editAhsData.hargaSatuanMaterial)) || 0)).toString() })}
                  error={!editAhsData.hargaSatuanUpah}
                  helperText={!editAhsData.hargaSatuanUpah ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Harga Satuan Material" name="hargaSatuanMaterial"
                  disabled={!isEditing}
                  placeholder="Harga satuan material" value={editAhsData.hargaSatuanMaterial || ""}
                  onChange={(e) => setEditAhsData({ ...editAhsData, hargaSatuanMaterial: e.target.value, totalHargaUpahMaterial: ((Number(editAhsData.volume) * Number(e.target.value)) + ((Number(editAhsData.volume) * Number(editAhsData.hargaSatuanUpah)) || 0)).toString() })}
                  error={!editAhsData.hargaSatuanMaterial}
                  helperText={!editAhsData.hargaSatuanMaterial ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Total Harga Upah+Material (Rp)" name="totalHarga"
                  // disabled={!isEditing}
                  placeholder="Total harga satuan upah+material" value={editAhsData.totalHargaUpahMaterial || ""}
                  onChange={(e) => setEditAhsData({ ...editAhsData, proyeksiPendapatan: ((Number(editAhsData?.totalHarga || 0)) - (Number(editAhsData.totalHargaUpahMaterial) - Number(editAhsData.biayaTidakLangsung)) || 0).toString() })}
                  disabled
                />

                {/* <TextField
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={editAhsData.volume}
                  onChange={(e) => setEditAhsData({ ...editAhsData, volume: e.target.value, totalHarga: (Number(editAhsData.totalAHS) * Number(e.target.value)) })}
                  error={!editAhsData.volume}
                  helperText={!editAhsData.volume ? "Mandatory Field" : ""}
                /> */}

                {/* <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={editAhsData.totalHarga}
                  disabled
                /> */}
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Harga Kontrak" name="hargaKontrak"
                  placeholder="Harga kontrak" value={projectEdit?.bidAmmount || ""}
                  disabled
                // onChange={(e) => setEditAhsData({ ...editAhsData, hargaKontrak: e.target.value })}
                // error={!editAhsData.hargaKontrak}
                // helperText={!editAhsData.hargaKontrak ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Biaya Tidak Langsung" name="biayaTidakLangsung"
                  disabled={!isEditing}
                  placeholder="Biaya Tidak Langsung" value={editAhsData.biayaTidakLangsung || ""}
                  onChange={(e) => setEditAhsData({ ...editAhsData, biayaTidakLangsung: e.target.value, proyeksiPendapatan: ((Number(editAhsData?.totalHarga || 0)) - Number(editAhsData.totalHargaUpahMaterial) - Number(e.target.value) || 0).toString() })}
                  error={!editAhsData.biayaTidakLangsung}
                  helperText={!editAhsData.biayaTidakLangsung ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Proyeksi Pendapatan" name="proyeksiPendapatan"
                  disabled={!isEditing}
                  placeholder="Proyeksi Pendapatan" value={editAhsData.proyeksiPendapatan || ""}
                  onChange={(e) => setEditAhsData({ ...editAhsData, proyeksiPendapatan: e.target.value })}
                  error={!editAhsData.proyeksiPendapatan}
                  helperText={!editAhsData.proyeksiPendapatan ? "Mandatory Field" : ""}
                />

                {/* <TextField
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={editAhsData.volume}
                  onChange={(e) => setEditAhsData({ ...editAhsData, volume: e.target.value, totalHarga: (Number(editAhsData.totalAHS) * Number(e.target.value)) })}
                  error={!editAhsData.volume}
                  helperText={!editAhsData.volume ? "Mandatory Field" : ""}
                /> */}

                {/* <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={editAhsData.totalHarga}
                  disabled
                /> */}
              </Box>


            </Box>



            {/* Right Side (Dropdowns & Inputs) */}
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }} gutterBottom>Vendor</Typography>
              <TextField
                select
                disabled={!isEditing}
                fullWidth label="Use Vendor" name="isVendorEdit"
                placeholder="Select Option" value={isVendorEdit}
                onChange={(e) => setIsVendorEdit(e.target.value)}
              >
                <MenuItem value="" disabled>Select Option</MenuItem>
                <MenuItem value="yes">Yes</MenuItem>
                <MenuItem value="no">No</MenuItem>
              </TextField>
              {/* <TextField
                select
                fullWidth label="Vendor" name="vendor"
                placeholder="Select Vendor" value={editAhsData.vendor}
                disabled={(isVendorEdit != "yes")}
              >
                <MenuItem value="" disabled>Select Vendor</MenuItem>
                {vendorOptions.map((option) => (
                  <MenuItem key={option.vendorId} value={option.vendorId}>
                    {option.vendorName}
                  </MenuItem>
                ))}
              </TextField> */}
              <Autocomplete
                fullWidth
                disabled={(isVendorEdit != "yes") && !isEditing}
                options={vendorOptions}
                getOptionLabel={(option) => option.vendorName || ""}
                value={
                  editAhsData?.vendor
                    ? vendorOptions.find((opt) => opt.vendorId === editAhsData.vendor) || null
                    : null
                }
                onChange={(event, newValue) => {
                  // handleAhsChangeOnEdit({
                  //   target: {
                  //     name: "vendor",
                  //     value: newValue ? newValue.vendorId : ""
                  //   }
                  // });
                  setEditAhsData({ ...editAhsData, vendor: newValue })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    disabled={!isEditing}
                    label="Vendor Name"
                    name="vendor"
                    placeholder="Enter vendor name"
                    fullWidth
                    error={!editAhsData.vendor}
                    helperText={!editAhsData.vendor ? "Mandatory Field" : ""}
                  />
                )}
              />
              <TextField
                fullWidth label="Vendor Project Value" name="vendorProjectValue"
                placeholder="Vendor Project Value" value={editAhsData.vendorProjectValue}
                onChange={(e) => setEditAhsData({ ...editAhsData, vendorProjectValue: e.target.value })}
                disabled={(isVendorEdit != "yes") && !isEditing}
              />
            </Box>
          </Box>

          {/* AHS */}

          {/* Left Side (Inputs & Map) */}
          <Box sx={{ flex: 3, display: isEditing ? "flex" : "none", flexDirection: "column", gap: 2, mt: 2 }} hidden={!isEditing}>

            <Button
              variant="outlined"
              disabled={!isEditing}
              color="primary"
              sx={{ width: 180 }}
              onClick={handleAddAhsToRapDetailOnEdit}
            >
              Tambahkan ke RAP Detail
            </Button>



          </Box>
          {/* Section A - RAP Review */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>A. RAP Review</Typography>
            <Box textAlign={"right"} sx={{ mb: 2 }}>
              <Button
                onClick={exportRabDetailToPDF}
                variant="outlined"
                startIcon={<PictureAsPdf />}
                color="error"
              >
                Export PDF
              </Button>
              <Button
                onClick={exportRabDetailToExcel}
                variant="outlined"
                startIcon={<Download />}
                color="success"
                sx={{ ml: 1 }}
              >
                Export Excel
              </Button>
            </Box>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>No</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Keterangan</TableCell>
                  <TableCell>Volume</TableCell>
                  <TableCell>Satuan</TableCell>
                  <TableCell>Harga Satuan Adjustment</TableCell>
                  <TableCell>Jumlah Harga</TableCell>
                  <TableCell>Harga Satuan Upah</TableCell>
                  <TableCell>Total Harga Upah</TableCell>
                  <TableCell>Harga Satuan Material</TableCell>
                  <TableCell>Total Harga Material</TableCell>
                  <TableCell>Total Harga Upah+Material</TableCell>
                  <TableCell>Biaya Tidak Langsung</TableCell>
                  <TableCell>Vendor Name</TableCell>
                  <TableCell>Vendor Value</TableCell>
                  <TableCell>Proyeksi Pendapatan (AHS-RAP)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rapDetailAddOnEdit.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <IconButton
                        disabled={!isEditing}
                        color="error"
                        onClick={() => {
                          handleDeleteRabDetailEdit(index);
                          // setRapDetailAdd((prev) => prev.filter((_, i) => i !== index));
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.category || row.ahs?.category}</TableCell>
                    <TableCell>{row.namaAHS}</TableCell>
                    <TableCell>{row.volume}</TableCell>
                    <TableCell>{row.satuanAHS || row.ahs?.satuanAHS}</TableCell>
                    <TableCell>{`Rp ${Number(row.hargaSatuan).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${Number(row.totalHarga).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${Number(row.hargaSatuanUpah).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${(Number(row.hargaSatuanUpah) * Number(row.volume)).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${Number(row.hargaSatuanMaterial).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${(Number(row.hargaSatuanMaterial) * Number(row.volume)).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${(Number(row.hargaSatuanMaterial) * Number(row.volume) + Number(row.hargaSatuanUpah) * Number(row.volume)).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{`Rp ${Number(row.biayaTidakLangsung).toLocaleString("id-ID")}`}</TableCell>
                    <TableCell>{row.vendor?.vendorName || row.vendor || ""}</TableCell>
                    <TableCell>{row.vendor?.value || row.vendorProjectValue || ""}</TableCell>
                    <TableCell>{`Rp ${Number(row.proyeksiPendapatan).toLocaleString("id-ID")}`}</TableCell>
                  </TableRow>
                ))}
                {/* Hitungan Akhir */}
                <TableRow>
                  <TableCell colSpan={7} align="right"><strong>Jumlah</strong></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalRabEdit).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalUpahEdit).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalMaterialEdit).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalUpahMaterialEdit).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalBiayaTidakLangsungEdit).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalVendorValueEdit).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${(totalProyeksiEdit).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={7} align="right">PPN {editRapData.ppn}%</TableCell>
                  <TableCell>
                    {`Rp ${Math.round(totalRabEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalUpahEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalMaterialEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalUpahMaterialEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalBiayaTidakLangsungEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalVendorValueEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalProyeksiEdit * Number(editRapData.ppn) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={7} align="right"><strong>Total</strong></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalRabEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalUpahEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalMaterialEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalUpahMaterialEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalBiayaTidakLangsungEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalVendorValueEdit * (Number(editRapData.ppn) + 100) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <strong>
                      {`Rp ${Math.round(totalProyeksiEdit * (100 + Number(editRapData.ppn)) / 100).toLocaleString("id-ID")}`}
                    </strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>


          </Box>

          {/* S-Curves */}

          {/* Left Side (Inputs & Map) */}
          <Box sx={{ flex: 2, display: isEditing ? "flex" : "none", flexDirection: "column", gap: 2, mt: 2 }} hidden={!isEditing}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>B. S-Curve</Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Autocomplete
                fullWidth
                disabled={!isEditing}
                options={availableDetailOptionsOnEdit}
                getOptionLabel={(option) => option.namaAHS || ""}
                value={availableDetailOptionsOnEdit.find(opt => opt.ahsId === rapDetailToSCurveAddOnEdit.ahsId) || null}
                onChange={(event, newValue) => {
                  handleDetailChangeOnEdit({
                    target: {
                      name: "ahsId",
                      value: newValue ? newValue.ahsId : ""
                    }
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    disabled={!isEditing}
                    label="AHS Name" name="namaAHS"
                    placeholder="Enter ahs name"
                    fullWidth error={!rapDetailToSCurveAddOnEdit.ahsId}
                    helperText={!rapDetailToSCurveAddOnEdit.ahsId ? "Mandatory Field" : ""}
                  />
                )}
              />
              <TextField
                fullWidth
                label="Total Upah+Material"
                name="totalHargaUpahMaterial"
                placeholder="Enter Total Upah+Material"
                value={String(rapDetailToSCurveAddOnEdit.totalHargaUpahMaterial || "0")}
                disabled
                error={!rapDetailToSCurveAddOnEdit.totalHargaUpahMaterial}
                helperText={!rapDetailToSCurveAddOnEdit.totalHargaUpahMaterial ? "Mandatory Field" : ""}
              />
              <TextField
                fullWidth label="Bobot" name="bobot"
                placeholder="Enter Bobot" value={String(rapDetailToSCurveAddOnEdit.bobot || "")}
                onChange={handleSCurveInputChangeOnEdit}
                disabled
                error={!rapDetailToSCurveAddOnEdit.bobot}
                helperText={!rapDetailToSCurveAddOnEdit.bobot ? "Mandatory Field" : ""}
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth label="Durasi (Minggu)" name="durasiMinggu"
                disabled={!isEditing}
                placeholder="Enter Durasi (Minggu)" value={String(rapDetailToSCurveAddOnEdit.durasiMinggu || "")}
                // disabled
                onChange={(e) => setRapDetailToSCurveAddOnEdit({ ...rapDetailToSCurveAddOnEdit, durasiMinggu: e.target.value, endDate: rapDetailToSCurveAddOnEdit.startDate ? dayjs(rapDetailToSCurveAddOnEdit.startDate).add(Number(e.target.value), 'week').format("YYYY-MM-DD") : "", bobotMingguan: (Number(rapDetailToSCurveAddOnEdit.bobot) / Number(e.target.value)) })}
                error={!rapDetailToSCurveAddOnEdit.durasiMinggu}
                helperText={!rapDetailToSCurveAddOnEdit.durasiMinggu ? "Mandatory Field" : ""}
              />
              <TextField
                fullWidth label="Bobot Mingguan" name="bobotMingguan"
                placeholder="Enter Bobot Mingguan" value={String(rapDetailToSCurveAddOnEdit.bobotMingguan || "")}
                disabled
                onChange={handleSCurveInputChangeOnEdit}
                error={!rapDetailToSCurveAddOnEdit.bobotMingguan}
                helperText={!rapDetailToSCurveAddOnEdit.bobotMingguan ? "Mandatory Field" : ""}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="Select Start Date"
                  disabled={!isEditing}
                  format="YYYY-MM-DD"
                  value={rapDetailToSCurveAddOnEdit.startDate ? dayjs(rapDetailToSCurveAddOnEdit.startDate) : null}
                  onChange={(newValue) => {
                    // if (isEditing) {
                    setRapDetailToSCurveAddOnEdit({ ...rapDetailToSCurveAddOnEdit, startDate: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "", endDate: newValue ? dayjs(newValue).add(Number(rapDetailToSCurveAddOnEdit.durasiMinggu), 'week').format("YYYY-MM-DD") : "" })
                    // }
                  }}
                  slotProps={{
                    textField: {
                      margin: "normal",
                      fullWidth: true,
                      sx: { mb: 1, mt: 0 },
                      name: "startDate",
                      error: !rapDetailToSCurveAddOnEdit.startDate,
                      helperText: !rapDetailToSCurveAddOnEdit.startDate ? "Mandatory Field" : "",
                    },
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  disabled
                  label="Select End Date"
                  format="YYYY-MM-DD"
                  value={rapDetailToSCurveAddOnEdit.endDate ? dayjs(rapDetailToSCurveAddOnEdit.endDate) : null}
                  onChange={(newValue) => {
                    // if (isEditing) {
                    handleSCurveInputChangeOnEdit({
                      target: {
                        name: "endDate",
                        value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                      },
                    });
                    // }
                  }}
                  slotProps={{
                    textField: {
                      margin: "normal",
                      fullWidth: true,
                      sx: { mb: 1, mt: 0 },
                      name: "endDate",
                      error: !rapDetailToSCurveAddOnEdit.endDate,
                      helperText: !rapDetailToSCurveAddOnEdit.endDate ? "Mandatory Field" : "",
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>

            <Button
              disabled={!isEditing}
              variant="outlined"
              color="primary"
              sx={{ width: 180 }}
              onClick={handleAddRAPToSCurveOnEdit}
            >
              Tambahkan ke S-Curve
            </Button>



          </Box>

          {/* Section B - S-Curve */}
          <Box sx={{ mt: 5 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Table S-Curve</Typography>
            <Box textAlign={"right"} sx={{ mb: 2 }}>
              <Button
                onClick={exportSCurveToPDF}
                variant="outlined"
                startIcon={<PictureAsPdf />}
                color="error"
              >
                Export PDF
              </Button>
              <Button
                onClick={exportSCurveToExcel}
                variant="outlined"
                startIcon={<Download />}
                color="success"
                sx={{ ml: 1 }}
              >
                Export Excel
              </Button>
            </Box>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>No</TableCell>
                  <TableCell>Category AHS</TableCell>
                  <TableCell>Keterangan</TableCell>
                  <TableCell>Total Harga Upah+ Material</TableCell>
                  <TableCell>Bobot</TableCell>
                  <TableCell>Bobot Minggu</TableCell>
                  <TableCell>Total Durasi</TableCell>
                  <TableCell>Start</TableCell>
                  <TableCell>End</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sCurveAddOnEdit.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <IconButton
                        color="error"
                        disabled={!isEditing}
                        onClick={() => handleDeleteSCurveEdit(index)}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.category || ""}</TableCell>
                    <TableCell>{row.namaAHS || ""}</TableCell>
                    <TableCell>{`Rp ${Number(row.totalHargaUpahMaterial)?.toLocaleString("id-ID") || "0"}`}</TableCell>
                    <TableCell>{row.bobot}</TableCell>
                    <TableCell>{row.bobotMingguan}</TableCell>
                    <TableCell>{row.durasiMinggu}</TableCell>
                    <TableCell>{row.startDate}</TableCell>
                    <TableCell>{row.endDate}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
          <Box sx={{ mt: 5 }} hidden={isEditing} ref={grafanaChartRef}>
            <img
              src={`https://103.23.30.133/api/grafana/render-scurve-rab-rap?orgId=1&from=${encodeURIComponent(ifFrom)}&to=${encodeURIComponent(ifTo)}&timezone=browser&var-rabId=${encodeURIComponent(editRapData.rabId)}&var-rapId=${encodeURIComponent(editRapData.id)}&theme=light&panelId=1&width=1000&height=500`}
              alt="SCurve"
              style={{ width: "100%", maxHeight: 400, objectFit: "contain" }}
              crossOrigin="anonymous"
            />
          </Box>
        </DialogContent>


        {/* Dialog Actions */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          {!isEditing ? (
            // Tombol Edit Muncul di Awal
            <Button onClick={() => setIsEditing(true)} variant="contained" color="primary" sx={{ width: 120 }}>
              EDIT
            </Button>
          ) : (
            // Tombol Save & Cancel Muncul Saat Edit
            <>
              <Button onClick={() => setIsEditing(false)} variant="outlined" color="error" sx={{ width: 120 }}>
                CANCEL
              </Button>
              <Button onClick={handleSubmitEditRap} variant="contained" color="success" sx={{ width: 120 }}>
                SAVE
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>




      {/* ======================= Filter Dialog ============================= */}
      <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)}>
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters.map((f, i) => i !== index && f.field).filter(Boolean);
            const availableOptions = availableFilters.filter((opt) => !usedFields.includes(opt.value));

            return (
              <Box key={index} display="flex" alignItems="center" gap={1} mb={2}>
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) => handleFilterChange(index, "field", e.target.value)}
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {filter.field === "projectType" ? (
                  <TextField
                    select
                    label="Project Type"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {projectTypes.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : filter.field === "source" ? (
                  <TextField
                    select
                    label="Source"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {sources.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : filter.field === "region" ? (
                  <TextField
                    select
                    label="Region"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {regions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : filter.field === "constructionPhase" ? (
                  <TextField
                    select
                    label="Project Phase"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {constructionPhases.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : filter.field === "startDate" ? (
                  <>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="Start Date"
                        format="YYYY-MM-DD"
                        value={startDateS ? dayjs(startDateS) : null}
                        onChange={(newValue) =>
                          setStartDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                        }
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            size: "small",
                            sx: { mt: 1, minWidth: 150 },
                          },
                        }}
                      />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="End Date"
                        format="YYYY-MM-DD"
                        value={endDateS ? dayjs(endDateS) : null}
                        onChange={(newValue) =>
                          setEndDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                        }
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            size: "small",
                            sx: { mt: 1, minWidth: 150 },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </>
                ) : filter.field === "endDate" ? (
                  <>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="Start Date"
                        format="YYYY-MM-DD"
                        value={startDateE ? dayjs(startDateE) : null}
                        onChange={(newValue) =>
                          setStartDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                        }
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            size: "small",
                            sx: { mt: 1, minWidth: 150 },
                          },
                        }}
                      />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="End Date"
                        format="YYYY-MM-DD"
                        value={endDateE ? dayjs(endDateE) : null}
                        onChange={(newValue) =>
                          setEndDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                        }
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            size: "small",
                            sx: { mt: 1, minWidth: 150 },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </>
                ) : filter.field === "valueEstimation" ? (
                  <>
                    <TextField
                      label="Value Min"
                      variant="outlined"
                      size="small"
                      value={valueMin}
                      onChange={(e) =>
                        setValueMin(e.target.value)
                      }
                      sx={{ mt: 1 }}
                    />
                    <TextField
                      label="Value Max"
                      variant="outlined"
                      size="small"
                      value={valueMax}
                      onChange={(e) =>
                        setValueMax(e.target.value)
                      }
                      sx={{ mt: 1 }}
                    />
                  </>

                ) : (
                  <TextField
                    label="Value"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1 }}
                  />
                )}

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button variant="contained" onClick={handleApplyFilters} disabled={isLoading}>
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default RAPPage;


